import { c as getElement, r as registerInstance, d as createEvent, h } from './index-34617187.js';
import * as _ from 'lodash-es';
import { isEqual, isEmpty, get } from 'lodash-es';
import moment from 'moment';
import { m as mapDateFormat, a as strToDateObj, d as dateObjArraysEqual, q as valuesToString, h as dateBoundHandler, p as dateValueToString, S as SPACE_REGEX, i as isRelativeValue } from './bxf-date-input.utils-c1de678d.js';
import { b as BxfOverlayCalendarSettingsController, B as BxfCalendarCell, a as BxfCalendarSettingsConstants } from './bxf-calendar-settings.constants-ca8e3e33.js';
import { B as BxfCalendarConstants, a as BxfDatePickerDateFormatEnum, b as BxfDatePickerSeparatorsEnum } from './bxf-date-picker-separators.enum-a0b9baeb.js';
import { u as uuidv4 } from './uuidv4-06ebe3ff.js';
import { Q as eventPath, P as WindowEventMap, j as getShadowRootElement, w as getKeyboardFocusCSS, z as BXF_ASSISTIVE_TEXT_HIDDEN, l as createSelector, O as AriaAttr } from './bxf-utils-3908c3c5.js';
import { B as BxfSelectConstants } from './bxf-select.constants-bd33f8cc.js';
import { i as isUsingI18n, B as BxfI18n, t as translateKeys } from './i18n.config-355137b0.js';
import { b as BxfOverlayTriggerEnum } from './overlay-controller-8ff05c99.js';
import { a as BxfDynamicPositionEnum } from './bxf-chat-canvas.constants-0879888b.js';
import { g as getParentOverlayContainer } from './get-parent-overlay-container-5aaa107a.js';
import { c as captureDefaultInputEvent } from './bxf-telemetry-utils-bf08318e.js';
import { F as FocusIndexManager } from './focus-index-manager-d376b5ea.js';
import { g as getReference } from './get-reference-7dba34d1.js';
import { F as FocusTrap, B as BxfPositionConstants } from './focus-trap-023cd6d1.js';
import { B as BxfPopoverTriggerEnum } from './bxf-popover-trigger.enum-2f385a77.js';
import { R as Role } from './role.enum-c3c8cd89.js';
import { B as BxfButtonSizeEnum } from './button-size.enum-43a454f0.js';
import { B as BxfIconTypeEnum } from './bxf-icon.type-4afcd2ad.js';
import { B as BxfButtonTypeEnum } from './button-type.enum-3452e5b6.js';
import { K as KeyboardEventKey } from './keyboard-event-key.enum-2f6c4d91.js';
import { H as HasPopupValue } from './has-popup-value.enum-d8e40cc4.js';
import './bxf-text-input.utils-6d1dfc5c.js';
import './query-selector-shadow-dom-dc946919.js';
import './overlay-dropdown-controller-d9d1cfbe.js';
import 'dompurify';
import './bxf-type-ahead.constants-d006f018.js';

const bxfCalendarCss = "button.sc-bxf-calendar:hover,a.sc-bxf-calendar:hover,input[type=radio].sc-bxf-calendar:hover,input[type=checkbox].sc-bxf-calendar:hover,input[type=radio].sc-bxf-calendar:checked:hover,input[type=checkbox].sc-bxf-calendar:checked:hover,svg.sc-bxf-calendar:hover{cursor:pointer}svg[disabled].sc-bxf-calendar:hover,button[disabled].sc-bxf-calendar:hover,label[disabled].sc-bxf-calendar:hover,input[type=checkbox].sc-bxf-calendar:disabled:hover,input[type=radio].sc-bxf-calendar:disabled:hover,input[type=checkbox].sc-bxf-calendar:checked:disabled:hover,input[type=radio].sc-bxf-calendar:checked:disabled:hover{cursor:default}.bxf__assistive-text--hidden.sc-bxf-calendar{position:absolute !important;left:-625rem;top:auto;width:0.0625rem;height:0.0625rem;overflow:hidden}.bxf-calendar__container.sc-bxf-calendar{display:table-caption;border:1px solid var(--calendar__border-color);border-bottom:1px solid var(--primary-action__color);border-radius:0.125rem;box-sizing:border-box;background-color:var(--widget__background-color);box-shadow:0 0.25rem 0.75rem 0 var(--popover__box-shadow-color);font-size:var(--font-size);overflow:hidden;color:var(--primary-text__color);padding:0 1rem}.bxf-calendar__container.sc-bxf-calendar:focus{outline:none}.bxf-calendar__container--standalone.sc-bxf-calendar{display:table-caption;border-radius:0.125rem;box-sizing:border-box;background-color:var(--widget__background-color);font-size:var(--font-size);overflow:hidden;color:var(--primary-text__color);border:none;box-shadow:none}.bxf-calendar__container--standalone.sc-bxf-calendar:focus{outline:none}.bxf-calendar__header.sc-bxf-calendar{display:flex;margin:1rem 0}.bxf-calendar__header--facet-btn.sc-bxf-calendar{margin-top:0.75rem}.bxf-calendar__header--static.sc-bxf-calendar{display:flex;font-weight:bold;margin-top:0.5rem}.bxf-calendar__header-months.sc-bxf-calendar{margin-right:0.5rem;width:7rem;height:2rem;outline:none}.bxf-calendar__header-years.sc-bxf-calendar{width:4.875rem;height:2rem;outline:none}.bxf-calendar__header-buttons.sc-bxf-calendar{display:flex;align-items:center;margin-top:0.25rem;margin-left:0.375rem}.bxf-calendar__header-buttons__xsmall.sc-bxf-calendar{width:1rem}.bxf-calendar__table.sc-bxf-calendar{min-height:11.375rem;margin:auto 0.125rem 0.75rem -0.125rem;height:auto;display:flex;flex-direction:column}.bxf-calendar__table--facet-btn.sc-bxf-calendar{margin-bottom:0.375rem}.bxf-calendar__footer--settings-icon.sc-bxf-calendar{padding-left:0.5rem}.bxf-calendar__table-row.sc-bxf-calendar{display:flex;margin-bottom:0.375rem}.bxf-calendar__footer--shortcuts-container.sc-bxf-calendar{padding:0.5rem 0;border-top:0.0625rem solid var(--calendar__border-color);display:flex;justify-content:flex-end}.bxf-calendar__calendar-note--container.sc-bxf-calendar{padding:0.5rem 0;border-bottom:0.0625rem solid var(--calendar__border-color);display:flex}.bxf-calendar__calendar-note.sc-bxf-calendar{line-height:1rem;font-size:0.75rem}.bxf-calendar__table-header.sc-bxf-calendar,.bxf-calendar__table-cell.sc-bxf-calendar,.bxf-calendar__table-cell--active_month.sc-bxf-calendar,.bxf-calendar__table-cell--not_selectable.sc-bxf-calendar,.bxf-calendar__table-cell--transparent.sc-bxf-calendar,.bxf-calendar__table-cell--inactive_month.sc-bxf-calendar{width:1.75rem;height:1.75rem;border:none;text-align:center;padding:0;display:flex;align-items:center;justify-content:center;margin:0 auto 0 0.375rem}.bxf-calendar__table-cell_range.sc-bxf-calendar{background-color:var(--date-picker__background-color--cell-hover);color:var(--calendar__text-color--hover) !important}.bxf-calendar__table-cell__range_selected.sc-bxf-calendar{background-color:var(--primary-action__color);color:var(--date-picker__text-color--cell-focused) !important}.bxf-calendar__footer--sunday.sc-bxf-calendar{background-color:var(--date-picker__background-color--cell-hover);color:var(--calendar__text-color--hover) !important}.bxf-calendar__footer--sunday-selected.sc-bxf-calendar{background-color:var(--primary-action__color);color:var(--date-picker__text-color--cell-focused) !important}.bxf-calendar__table-cell.sc-bxf-calendar button.sc-bxf-calendar,.bxf-calendar__table-cell--active_month.sc-bxf-calendar button.sc-bxf-calendar,.bxf-calendar__table-cell--not_selectable.sc-bxf-calendar button.sc-bxf-calendar,.bxf-calendar__table-cell--transparent.sc-bxf-calendar button.sc-bxf-calendar,.bxf-calendar__table-cell--inactive_month.sc-bxf-calendar button.sc-bxf-calendar{display:flex;align-items:center;flex-direction:column;border:none;background-color:transparent;font-size:var(--font-size);padding-top:0.3125rem;outline-offset:0.125rem;width:100%;height:100%;margin:0}.bxf-calendar__table-cell.sc-bxf-calendar button.sc-bxf-calendar:focus,.bxf-calendar__table-cell--active_month.sc-bxf-calendar button.sc-bxf-calendar:focus,.bxf-calendar__table-cell--not_selectable.sc-bxf-calendar button.sc-bxf-calendar:focus,.bxf-calendar__table-cell--transparent.sc-bxf-calendar button.sc-bxf-calendar:focus,.bxf-calendar__table-cell--inactive_month.sc-bxf-calendar button.sc-bxf-calendar:focus{outline:0.0625rem dotted var(--primary-action__color);outline:auto var(--primary-action__color)}.bxf-calendar__table-cell.sc-bxf-calendar button.bxf__focus--keyboard-only.sc-bxf-calendar:focus:not(:focus-visible),.bxf-calendar__table-cell--active_month.sc-bxf-calendar button.bxf__focus--keyboard-only.sc-bxf-calendar:focus:not(:focus-visible),.bxf-calendar__table-cell--not_selectable.sc-bxf-calendar button.bxf__focus--keyboard-only.sc-bxf-calendar:focus:not(:focus-visible),.bxf-calendar__table-cell--transparent.sc-bxf-calendar button.bxf__focus--keyboard-only.sc-bxf-calendar:focus:not(:focus-visible),.bxf-calendar__table-cell--inactive_month.sc-bxf-calendar button.bxf__focus--keyboard-only.sc-bxf-calendar:focus:not(:focus-visible){outline:0}.bxf-calendar__table-cell.sc-bxf-calendar button.sc-bxf-calendar:active,.bxf-calendar__table-cell--active_month.sc-bxf-calendar button.sc-bxf-calendar:active,.bxf-calendar__table-cell--not_selectable.sc-bxf-calendar button.sc-bxf-calendar:active,.bxf-calendar__table-cell--transparent.sc-bxf-calendar button.sc-bxf-calendar:active,.bxf-calendar__table-cell--inactive_month.sc-bxf-calendar button.sc-bxf-calendar:active{background-color:var(--primary-action__color) !important;color:var(--date-picker__text-color--cell-focused) !important}.bxf-calendar__table-cell.sc-bxf-calendar button.sc-bxf-calendar:hover,.bxf-calendar__table-cell--active_month.sc-bxf-calendar button.sc-bxf-calendar:hover,.bxf-calendar__table-cell--not_selectable.sc-bxf-calendar button.sc-bxf-calendar:hover,.bxf-calendar__table-cell--transparent.sc-bxf-calendar button.sc-bxf-calendar:hover,.bxf-calendar__table-cell--inactive_month.sc-bxf-calendar button.sc-bxf-calendar:hover{cursor:pointer;background-color:var(--date-picker__background-color--cell-hover);color:var(--calendar__text-color--hover)}.bxf-calendar__table-cell_range.sc-bxf-calendar,.bxf-calendar__table-cell__range_selected.sc-bxf-calendar{width:1.75rem;height:1.75rem;text-align:center;padding-left:0.375rem;display:flex;align-items:center;justify-content:center;margin:auto 0 auto 0}.bxf-calendar__table-cell_range.bxf-calendar__table-cell--disabled.sc-bxf-calendar,.bxf-calendar__table-cell__range_selected.bxf-calendar__table-cell--disabled.sc-bxf-calendar{background-color:var(--date-picker__background-color--cell-hover)}.bxf-calendar__table-cell_range.sc-bxf-calendar button.sc-bxf-calendar,.bxf-calendar__table-cell__range_selected.sc-bxf-calendar button.sc-bxf-calendar{display:flex;align-items:center;flex-direction:column;border:none;background-color:transparent;font-size:var(--font-size);padding:0.3125rem 0 0 0;outline-offset:0.125rem;width:100%;height:100%;margin:0}.bxf-calendar__table-cell_range.sc-bxf-calendar button.bxf-calendar__table-cell--disabled.sc-bxf-calendar,.bxf-calendar__table-cell__range_selected.sc-bxf-calendar button.bxf-calendar__table-cell--disabled.sc-bxf-calendar{background-color:var(--calendar__background-color--disabled)}.bxf-calendar__table-cell_range.sc-bxf-calendar button.sc-bxf-calendar:focus,.bxf-calendar__table-cell__range_selected.sc-bxf-calendar button.sc-bxf-calendar:focus{outline:0.0625rem dotted var(--primary-action__color);outline:auto var(--primary-action__color)}.bxf-calendar__table-cell_range.sc-bxf-calendar button.bxf__focus--keyboard-only.sc-bxf-calendar:focus:not(:focus-visible),.bxf-calendar__table-cell__range_selected.sc-bxf-calendar button.bxf__focus--keyboard-only.sc-bxf-calendar:focus:not(:focus-visible){outline:0}.bxf-calendar__table-cell_range.sc-bxf-calendar button.sc-bxf-calendar:active,.bxf-calendar__table-cell__range_selected.sc-bxf-calendar button.sc-bxf-calendar:active{background-color:var(--primary-action__color);color:var(--date-picker__text-color--cell-focused) !important}.bxf-calendar__table-cell--range-bound.sc-bxf-calendar,.bxf-calendar__footer--sunday-selected.sc-bxf-calendar{background-color:var(--primary-action__color);color:var(--date-picker__text-color--cell-focused) !important}.bxf-calendar__table-cell--range-bound.sc-bxf-calendar button.sc-bxf-calendar,.bxf-calendar__footer--sunday-selected.sc-bxf-calendar button.sc-bxf-calendar{display:flex;align-items:center;flex-direction:column;border:none;background-color:transparent;font-size:var(--font-size);padding-top:0.3125rem;width:100%;height:100%}.bxf-calendar__table-cell--range-bound.sc-bxf-calendar button.sc-bxf-calendar:hover,.bxf-calendar__footer--sunday-selected.sc-bxf-calendar button.sc-bxf-calendar:hover{background-color:var(--date-picker__background-color--cell-hover) !important;color:var(--calendar__text-color--hover) !important}.bxf-calendar__table-cell--inactive_month.sc-bxf-calendar{color:var(--disabled-text__color)}.bxf-calendar__table-cell--not_selectable.sc-bxf-calendar,.bxf-calendar__table-cell--transparent.sc-bxf-calendar{pointer-events:none}.bxf-calendar__table-cell--transparent.sc-bxf-calendar{color:transparent}.bxf-calendar__table-cell--active_month.sc-bxf-calendar{color:var(--primary-text__color)}.bxf-calendar__table-cell--today.sc-bxf-calendar{color:var(--primary-text__color)}.bxf-calendar__table-cell--today.sc-bxf-calendar:hover{border-radius:1.25rem !important;background-color:var(--calendar__background-color--today) !important;color:var(--primary-text__color) !important}.bxf-calendar__table-cell--today.sc-bxf-calendar button.sc-bxf-calendar{display:flex;align-items:center;flex-direction:column;border:none;font-size:var(--font-size);padding-top:0.3125rem;border-radius:1.25rem;background-color:var(--calendar__background-color--today);outline:0.0625rem solid transparent;outline-offset:0.125rem;width:100%;height:100%;margin:0}.bxf-calendar__table-cell--today.sc-bxf-calendar button.sc-bxf-calendar:focus{outline:0.0625rem dotted var(--primary-action__color);outline:auto var(--primary-action__color)}.bxf-calendar__table-cell--today.sc-bxf-calendar button.bxf__focus--keyboard-only.sc-bxf-calendar:focus:not(:focus-visible){outline:0}.bxf-calendar__table-cell--today.sc-bxf-calendar button.sc-bxf-calendar:active{border-radius:0 !important;background-color:var(--primary-action__color) !important;color:var(--date-picker__text-color--cell-focused) !important}.bxf-calendar__table-cell--selected.sc-bxf-calendar{background-color:var(--primary-action__color);color:var(--date-picker__text-color--cell-focused)}.bxf-calendar__table-cell--selected.sc-bxf-calendar button.sc-bxf-calendar{display:flex;align-items:center;flex-direction:column;border:none;background-color:transparent;font-size:var(--font-size);padding-top:0.3125rem;border-radius:0;outline-offset:0.125rem;width:100%;height:100%;margin:0}.bxf-calendar__table-cell--selected.sc-bxf-calendar button.sc-bxf-calendar:focus{outline:0.0625rem dotted var(--primary-action__color);outline:auto var(--primary-action__color)}.bxf-calendar__table-cell--selected.sc-bxf-calendar button.bxf__focus--keyboard-only.sc-bxf-calendar:focus:not(:focus-visible){outline:0}.bxf-calendar__table-cell--selected.sc-bxf-calendar button.sc-bxf-calendar:hover{background-color:var(--primary-action__color);color:var(--date-picker__text-color--cell-focused)}.bxf-calendar__table-cell--selected.sc-bxf-calendar button.sc-bxf-calendar:active{background-color:var(--date-picker__background-color--cell-hover);color:var(--primary-text__color)}.bxf-calendar__table-cell--disabled.sc-bxf-calendar{color:var(--calendar__text-color--disabled) !important;background-color:var(--calendar__background-color--disabled);pointer-events:none}.bxf-calendar__badge.sc-bxf-calendar,.bxf-calendar__badge--holiday.sc-bxf-calendar,.bxf-calendar__footer__badge--holiday.sc-bxf-calendar,.bxf-calendar__badge--markerA.sc-bxf-calendar,.bxf-calendar__footer__badge--markerA.sc-bxf-calendar,.bxf-calendar__badge--markerB.sc-bxf-calendar,.bxf-calendar__footer__badge--markerB.sc-bxf-calendar{margin:0.1875rem 0.0625rem 0 0.0625rem;padding:0;width:0.25rem;height:0.25rem;border:none;font-weight:bold}.bxf-calendar__badge--holiday.sc-bxf-calendar,.bxf-calendar__footer__badge--holiday.sc-bxf-calendar{height:0.25rem;width:0.25rem;border-radius:0.25rem;background-color:var(--calendar__background-color--holiday)}.bxf-calendar__footer__badge--holiday.sc-bxf-calendar{width:0.5rem;height:0.5rem}.bxf-calendar__footer__label--text.sc-bxf-calendar{font-size:0.8125rem}.bxf-calendar__badge--markerA.sc-bxf-calendar,.bxf-calendar__footer__badge--markerA.sc-bxf-calendar{width:0.21875rem;height:0.21875rem;box-sizing:border-box;transform:rotate(-45deg);background-color:var(--calendar__background-color--markerA)}.bxf-calendar__footer__badge--markerA.sc-bxf-calendar{width:0.4375rem;height:0.4375rem}.bxf-calendar__table-cell--invalid-range.sc-bxf-calendar{background-color:var(--primary-action__color) !important}.bxf-calendar__table-cell--invalid-range.sc-bxf-calendar button.sc-bxf-calendar{display:flex;align-items:center;flex-direction:column;border:none;background-color:var(--calendar__background-color--disabled) !important;font-size:var(--font-size);padding-top:0.3125rem;border-radius:0;outline-offset:0.125rem;width:100%;height:100%;margin:0}.bxf-calendar__table-cell--invalid-range.sc-bxf-calendar button.sc-bxf-calendar:focus{outline:0.0625rem dotted var(--primary-action__color);outline:auto var(--primary-action__color)}.bxf-calendar__table-cell--invalid-range.sc-bxf-calendar button.bxf__mouse-focus.sc-bxf-calendar:focus{outline:0}.bxf-calendar__table-cell--invalid-range.sc-bxf-calendar button.sc-bxf-calendar:active{background-color:var(--calendar__background-color--disabled) !important;color:var(--primary-text__color)}.bxf-calendar__badge--markerB.sc-bxf-calendar,.bxf-calendar__footer__badge--markerB.sc-bxf-calendar{width:0rem;height:0rem;border-left:0.15625rem solid transparent;border-right:0.15625rem solid transparent;border-bottom:0.28125rem solid var(--calendar__background-color--markerB)}.bxf-calendar__footer__badge--markerB.sc-bxf-calendar{border-left:0.3125rem solid transparent;border-right:0.3125rem solid transparent;border-bottom:0.5625rem solid var(--calendar__background-color--markerB)}.bxf-calendar__popover__badge--holiday.sc-bxf-calendar{display:inline-flex !important;overflow:visible;width:0.375rem;height:0.375rem;background-color:var(--calendar__background-color--holiday);border-radius:0.5rem;margin-left:0.0625rem;margin-right:0.1875rem;border:none;font-weight:bold;padding:0}.bxf-calendar__popover__badge--markerA.sc-bxf-calendar{width:0.34375rem;height:0.34375rem;overflow:visible;background-color:var(--calendar__background-color--markerA);transform:rotate(-45deg) !important;display:inline-flex !important;margin-left:0.0625rem;margin-right:0.1875rem;border:none;font-weight:bold;padding:0}.bxf-calendar__popover__badge--markerB.sc-bxf-calendar{width:0;height:0;overflow:visible;border-left:0.25rem solid transparent;border-right:0.25rem solid transparent;border-bottom:0.5rem solid var(--calendar__background-color--markerB);display:inline-flex !important;margin-right:0.25rem;border:none;font-weight:bold;padding:0}.bxf-calendar__key__container.sc-bxf-calendar{margin-bottom:0.75rem;display:inline-block}.bxf-calendar-popover__container.sc-bxf-calendar{margin:-0.75rem}.bxf-calendar__overlay--padding.sc-bxf-calendar{margin:0 -1rem;padding:0.5rem 1rem}.bxf-calendar__key__item__container.sc-bxf-calendar{display:inline-flex;border:none;background-color:transparent;padding:0 0.5rem 0.25rem 0}.bxf-calendar__key__item__container.sc-bxf-calendar:hover{cursor:pointer}.bxf-calendar__shortcut__separator.sc-bxf-calendar{padding-left:0.5rem;padding-right:0.5rem}.bxf-calendar__badge__label.sc-bxf-calendar{padding-right:0.25rem;padding-left:0.25rem;color:var(--primary-text__color);font-size:var(--font-size);display:inline-flex}.bxf-calendar__badge__positioning.sc-bxf-calendar{margin-top:-0.25rem;display:inline-flex;pointer-events:none}.bxf-calendar__footer.sc-bxf-calendar{height:1.5rem;margin-bottom:0.75rem;display:flex;justify-content:space-between}.bxf-calendar__footer--selected.sc-bxf-calendar{color:var(--primary-action__color)}.bxf-calendar__footer--reset.sc-bxf-calendar{padding-left:0.5rem;padding-top:0.25rem}.bxf-calendar__footer--right.sc-bxf-calendar{display:flex;width:100%;justify-content:right;line-height:1.5rem;margin-right:0rem}.bxf-calendar__footer--label.sc-bxf-calendar{display:flex;color:var(--secondary-text__color)}.bxf-calendar__footer--label.sc-bxf-calendar .bxf-calendar__footer--separator.sc-bxf-calendar{margin:0 0.25rem}.bxf-calendar__footer--select.sc-bxf-calendar{padding-left:0.25rem;width:7.5rem}.bxf-calendar__footer--settings.sc-bxf-calendar{display:flex}.bxf-calendar__footer--settings.sc-bxf-calendar bxf-button.sc-bxf-calendar{line-height:2rem}@media (forced-colors: active){.bxf-calendar__table-cell--selected.sc-bxf-calendar{background-color:Highlight}.bxf-calendar__table-cell--selected.sc-bxf-calendar:hover{background-color:Highlight}.bxf-calendar__badge--holiday.sc-bxf-calendar,.bxf-calendar__footer__badge--holiday.sc-bxf-calendar,.bxf-calendar__badge--markerA.sc-bxf-calendar,.bxf-calendar__footer__badge--markerA.sc-bxf-calendar,.bxf-calendar__badge--markerB.sc-bxf-calendar,.bxf-calendar__footer__badge--markerB.sc-bxf-calendar,.bxf-calendar__popover__badge--holiday.sc-bxf-calendar,.bxf-calendar__popover__badge--markerA.sc-bxf-calendar,.bxf-calendar__popover__badge--markerB.sc-bxf-calendar{background-color:CanvasText}}";
const BxfCalendarStyle0 = bxfCalendarCss;

const { FULL_MONTH, FULL_YEAR, TABLE, TABLE_FACET_BTN, TABLE_ROW, TABLE_CELL_ACTIVE_MONTH, TRANSPARENT_CELL, TABLE_CELL, TABLE_CELL_TODAY, TABLE_CELL_SELECTED, BADGE, SMALL, HOLIDAYS_LABEL: HOLIDAYS_LABEL$1, HOLIDAY_BADGE, TABLE_HEADER, HEADER, HEADER_FACET_BTN, CELL_NOT_SELECTABLE, CELL_RANGE, CELL_RANGE_SELECTED, DEFAULT_MAX_YEAR, DEFAULT_MIN_YEAR, INVALID_RANGE, STATIC_HEADER, MONTH_LABEL, SECONDARY_TEXT_COLOR: SECONDARY_TEXT_COLOR$1, MONTHS_BOX, YEAR_LABEL, OVERLAY_PADDING, KEY_CONTAINER: KEY_CONTAINER$1, SHORTCUTS_CONTAINER, CALENDAR_NOTE_CONTAINER, CALENDAR_NOTE, KEY_ITEM: KEY_ITEM$1, YEARS_BOX, BUTTONS_BOX, BUTTON_XSMALL, FOOTER, FOOTER_TODAY_LABEL, HOLIDAY_FOOTER_BADGE: HOLIDAY_FOOTER_BADGE$1, BADGE_POSITIONING: BADGE_POSITIONING$1, MARKER_A_BADGE, MARKER_A_FOOTER_BADGE: MARKER_A_FOOTER_BADGE$1, MARKER_B_BADGE, MARKER_B_FOOTER_BADGE: MARKER_B_FOOTER_BADGE$1, FOOTER_BADGE_LABEL: FOOTER_BADGE_LABEL$1, FOOTER_RIGHT: FOOTER_RIGHT$1, CONTAINER, SHORTCUT_SEPARATOR, SEPARATOR, DEFAULT_US: DEFAULT_US$1, DIALOG: DIALOG$1, LABEL: LABEL$1, FOOTER_LABEL_TEXT, SETTINGS, SPLIT_BUTTON_MENU, STANDALONE_CONTAINER, FOOTER_SETTINGS, FOOTER_SELECT: FOOTER_SELECT$1, FOOTER_DONE_LABEL, FOOTER_SETTINGS_ICON, SETTINGS_CONTAINER: SETTINGS_CONTAINER$1, PREV_MONTH, NEXT_MONTH, HEADER_PREV_MONTH, HEADER_NEXT_MONTH, TODAY_MENU_CONTAINER, FOOTER_TODAY, FOOTER_RESET, CELL_POPOVER_CONTAINER, RESET, TABLE_CELL_INACTIVE_MONTH, } = BxfCalendarConstants.STRING;
const { CLASSNAME } = BxfPositionConstants.STRING;
const RADIX = 10;
const BxfCalendar = class {
    _constants = BxfCalendarConstants;
    _years = [];
    _months;
    _days;
    _weekend;
    _activeMonthFlag = false;
    _daysCounter;
    _todayClickHandler;
    _resetClickHandler;
    _overlay;
    _todayRef;
    _settingsButtonRef;
    _tableRef;
    _secondaryTextColor = SECONDARY_TEXT_COLOR$1;
    _calendarSettingsRef;
    _calendarRef;
    _dateFormat = BxfDatePickerDateFormatEnum.DD_MM_YYYY;
    _doubleDates = false;
    _resetRef;
    i18n;
    MONTHS_BXF_ID = uuidv4();
    YEARS_BXF_ID = uuidv4();
    CALENDARS_BXF_ID = uuidv4();
    TODAY_BXF_ID = uuidv4();
    HOLIDAY_BXF_ID = uuidv4();
    MARKER_A_BXF_ID = uuidv4();
    MARKER_B_BXF_ID = uuidv4();
    get host() { return getElement(this); }
    /**
     * Sets the display style of the calendar based on the provided value.
     * @param {boolean} newValue - The new value indicating whether the calendar should be displayed or not.
     */
    handleCalendarView(newValue) {
        this.calendarDisplayStyle = newValue ? 'table-caption' : 'none';
    }
    eventDateSeparatorChangeHandler(newValue) {
        if (_.isEmpty(newValue))
            this.eventDateSeparator = this.separator;
    }
    inputDateFormatChangeHandler(newValue) {
        this.dateFormat = mapDateFormat(newValue);
    }
    displayDateFormatChangeHandler(newValue) {
        this.displayDateFormat = mapDateFormat(newValue);
    }
    /**
     * @internal
     * This event is emitted when calendar is rendered
     */
    calendarConnected;
    /**
     * This event is emitted when calendar's footer is clicked
     */
    footerClicked;
    /**
     * This event is emitted on change of value inside text input
     */
    calendarValueChanged;
    /**
     * This event is emitted when date (day) changes
     */
    dateChanged;
    /**
     * This event is emitted when month changes
     */
    monthChanged;
    /**
     * This event is emitted when year changes
     */
    yearChanged;
    /**
     * This event is emitted when date (day, month or year) is selected
     */
    dateSelected;
    /**
     * This event is emitted when a separator is selected in settings panel
     */
    separatorSelected;
    /**
     * This event is emitted when a calendar is selected in settings panel
     */
    calendarSelected;
    /**
     * Start and/or end date for a range of dates has been selected or changed
     */
    rangeDateSelectionChanged;
    /**
     * This event is emitted when date format is selected in settings panel
     */
    dateFormatSelected;
    /**
     * This event is emitted when a shortcut is clicked
     */
    shortcutClicked;
    /**
     * This event is emitted when an item in the today button inline menu is selected.
     */
    todayButtonMenuItemClicked;
    keyDisplayChanged;
    /**
     * Public method that opens the settings overlay
     */
    async openSettings() {
        this.isSettingsVisible = true;
    }
    /**
     * Checks if any date (if only given a start value) or dates within the specified range is disabled.
     * If no parameters are inputted:
     * - for range calendars the first and second dates in `this.values` will be used.
     * - for single date calendars the first date in `this.values` will be used.
     * - if multi-select calendar, all dates in `this.values` will be checked.
     * - if no dates are available, the method will return `false`.
     *
     * @param {moment.Moment} [startDateMoment] - The start date of the range to check. If not provided, the first date in `this.values` will be used.
     * @param {moment.Moment} [endDateMoment] - The end date of the range to check.
     * @returns {Promise<boolean>} - A promise that resolves to `true` if any date within the range is disabled, otherwise `false`.
     */
    async isDisabledDate(startDateMoment, endDateMoment) {
        if (!startDateMoment && !this.values)
            return false;
        let date = startDateMoment || this.dateObjToMoment(this.values[0]);
        if (endDateMoment || this.values?.length < 3) {
            const end = endDateMoment || this.dateObjToMoment(this.values[1]) || date;
            while (date?.isSameOrBefore(end)) {
                if (this.isCellDisabled(date)) {
                    return true;
                }
                date = date.clone().add(1, 'day');
            }
        }
        return (this.values?.findIndex((v) => this.isCellDisabled(this.dateObjToMoment(v))) !== -1 || false);
    }
    /**
     * Public method that closes the settings overlay
     */
    async closeSettings() {
        this.isSettingsVisible = false;
    }
    /**
     * This method closes the calendar component when triggered and updates calendar value
     */
    async close() {
        this.updateState(false);
    }
    singleValueChangeHandler() {
        this.values = strToDateObj(this.value, this.separator, this.dateFormat);
    }
    valueChangeHandler(newValues, oldValues) {
        /* istanbul ignore else */
        if (!dateObjArraysEqual(newValues, oldValues)) {
            /* istanbul ignore else */
            if (newValues) {
                this.valueStr = valuesToString(newValues, this.activeYear);
                this.selectedDays = new Set(this.valueStr);
                this.isRange && this.rangeHandler();
                if (newValues?.length && this.isHeaderDynamic) {
                    this.initCalendar(this.calendarValueOnReopen);
                }
            }
        }
    }
    calendarOpenHandler(newValue) {
        if (newValue) {
            this._overlay?.openOverlayWithPosition();
        }
        else {
            /* istanbul ignore else */
            if (this._overlay) {
                this._overlay.close();
                this._overlay = null;
            }
            this.closeCalendarSettings();
        }
    }
    minDateHandler() {
        this.minDateSelectable = dateBoundHandler(this.minDate, this.minYear, this.separator, this.dateFormat, true);
    }
    maxDateHandler() {
        this.maxDateSelectable = dateBoundHandler(this.maxDate, this.maxYear, this.separator, this.dateFormat, false);
    }
    /**
     * Update activeCalendar when footerLabel dynamically changed
     * 	and settingsSelectData empty
     */
    footerLabelHandler(newValue, oldValue) {
        if (newValue !== oldValue) {
            this.updateActiveCalendar(this.settingsSelectData, newValue);
        }
    }
    /**
     * Update activeCalendar when settingsSelectData dynamically changed
     */
    settingsSelectDataHandler(newValue, oldValue) {
        if (!_.isEqual(oldValue, newValue)) {
            this.updateActiveCalendar(newValue, this.footerLabel);
        }
    }
    openCalendarSettings() {
        /* istanbul ignore else */
        this._overlay?.openOverlayWithPosition();
    }
    closeCalendarSettings() {
        setTimeout(async () => {
            this.isSettingsVisible = false;
        }, 50);
    }
    selectionChangedHandler(event) {
        const select = eventPath(event).find((elm) => elm.nodeName === BxfSelectConstants.COMPONENT_NAME.toUpperCase());
        const bxfId = _.get(select, 'dataset.bxfId');
        /* istanbul ignore else */
        if (bxfId === this.MONTHS_BXF_ID) {
            this.monthSelectionHandler(event);
        }
        else if (bxfId === this.YEARS_BXF_ID) {
            this.yearSelectionHandler(event);
        }
        else if (bxfId === this.CALENDARS_BXF_ID) {
            this.calendarSelectionHandler(event);
        }
    }
    keyDisplayChangedHandler(event) {
        const bxfId = event.detail?.value;
        /* istanbul ignore else */
        if (bxfId === this.HOLIDAY_BXF_ID) {
            this.holidayEnabled =
                this.holidayEnabled === '' ? this._secondaryTextColor : '';
        }
        else if (bxfId === this.MARKER_A_BXF_ID) {
            this.markerAEnabled =
                this.markerAEnabled === '' ? this._secondaryTextColor : '';
        }
        else if (bxfId === this.MARKER_B_BXF_ID) {
            this.markerBEnabled =
                this.markerBEnabled === '' ? this._secondaryTextColor : '';
        }
    }
    // TODO: Add CustomEvent type
    dropdownOpenedChangedHandler(event) {
        const path = eventPath(event);
        /* istanbul ignore else */
        if (path.includes(this._monthRef)) {
            this._yearRef.close();
        }
        else if (path.includes(this._yearRef)) {
            this._monthRef.close();
        }
    }
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.calendarConnected = createEvent(this, "calendarConnected", 7);
        this.footerClicked = createEvent(this, "footerClicked", 7);
        this.calendarValueChanged = createEvent(this, "calendarValueChanged", 7);
        this.dateChanged = createEvent(this, "dateChanged", 7);
        this.monthChanged = createEvent(this, "monthChanged", 7);
        this.yearChanged = createEvent(this, "yearChanged", 7);
        this.dateSelected = createEvent(this, "dateSelected", 7);
        this.separatorSelected = createEvent(this, "separatorSelected", 7);
        this.calendarSelected = createEvent(this, "calendarSelected", 7);
        this.rangeDateSelectionChanged = createEvent(this, "rangeDateSelectionChanged", 7);
        this.dateFormatSelected = createEvent(this, "dateFormatSelected", 7);
        this.shortcutClicked = createEvent(this, "shortcutClicked", 7);
        this.todayButtonMenuItemClicked = createEvent(this, "todayButtonMenuItemClicked", 7);
        this.keyDisplayChanged = createEvent(this, "keyDisplayChanged", 7);
        this.filterMonths = false;
        this.initWithToday = false;
        this.minDateSelectable = {};
        this.maxDateSelectable = {};
        this.calendarNote = undefined;
        this.isRange = false;
        this.initActiveMonth = undefined;
        this.initActiveYear = undefined;
        this.values = [];
        this.value = undefined;
        this.isCalendarVisible = true;
        this.hasMarkerKey = true;
        this.defaultPopoverHeader = 'Events';
        this.isOverlay = false;
        this.maxDaysSelectable = 1;
        this.isHeaderDynamic = true;
        this.isTodayHighlighted = true;
        this.hideInactiveDateDetails = false;
        this.datePickerRef = undefined;
        this.hasSeparatorSettings = true;
        this.hasDateFormatSettings = true;
        this.eventData = {};
        this.eventDateSeparator = undefined;
        this.holidays = {};
        this.customDateMarkerA = {};
        this.customDateMarkerB = {};
        this.disableWeekends = false;
        this.disabledDates = [];
        this.showMarkerPopovers = false;
        this.isFooterDisabled = false;
        this.footerLabel = DEFAULT_US$1;
        this.hideDatesOutsideActiveMonth = false;
        this.hasTodayInFooter = true;
        this.dateFormat = BxfDatePickerDateFormatEnum.DD_MM_YYYY;
        this.displayDateFormat = BxfDatePickerDateFormatEnum.DD_MMM_YYYY;
        this.separator = BxfDatePickerSeparatorsEnum.DASH;
        this.keepTodayEnabled = false;
        this.settingsSelectData = [];
        this.todayButtonMenuData = [];
        this.showTodayButtonAsShortcut = false;
        this.footerShortcutData = [];
        this.isDisabled = false;
        this.isTracking = true;
        this.isMonthSelectDisabled = false;
        this.isYearSelectDisabled = false;
        this.trackingData = undefined;
        this.parentOverlayContainerSelector = 'body';
        this.dataTestSuffix = undefined;
        this.hasCalendarFooter = false;
        this.hasFooterLabel = true;
        this.hasFooterSettings = false;
        this.minYear = undefined;
        this.maxYear = undefined;
        this.minDate = undefined;
        this.maxDate = undefined;
        this.keepMouseFocus = false;
        this.isDatesUnselectable = true;
        this.isDialog = true;
        this.isFacetBtn = false;
        this.namespaceI18n = undefined;
        this.i18nKeys = undefined;
        this.calendarSettingsI18nKeys = undefined;
        this.today = undefined;
        this.resetValue = undefined;
        this.activeMonth = undefined;
        this.activeYear = undefined;
        this.activeDate = undefined;
        this.activeCalendar = undefined;
        this.inputValueMoment = undefined;
        this.isSettingsVisible = false;
        this.isPrevDisabled = false;
        this.isNextDisabled = false;
        this.holidayEnabled = '';
        this.markerAEnabled = '';
        this.markerBEnabled = '';
        this.translatedFooterLabel = this.footerLabel;
        this.monthLabel = MONTH_LABEL;
        this.yearLabel = YEAR_LABEL;
        this.footerTodayLabel = FOOTER_TODAY_LABEL;
        this.settings = SETTINGS;
        this.prevMonth = PREV_MONTH;
        this.nextMonth = NEXT_MONTH;
        this.allMonths = this._constants.MONTHS;
        this.allDays = this._constants.DAYS;
        this.allFullDays = this._constants.FULL_DAYS;
        this.selectedDays = new Set();
        this.valueStr = undefined;
        this.startRange = null;
        this.endRange = null;
        this.calendarDisplayStyle = undefined;
        this._todayClickHandler = this.todayClickedHandler.bind(this);
        this._resetClickHandler = this.resetClickedHandler.bind(this);
        this.resetButtonRefHandler = this.resetButtonRefHandler.bind(this);
        this.calendarRefHandler = this.calendarRefHandler.bind(this);
        this.updateState = this.updateState.bind(this);
        this.isOutsideOverlay = this.isOutsideOverlay.bind(this);
        this.settingsKeyDownHandler = this.settingsKeyDownHandler.bind(this);
        this.calendarSelectedHandler = this.calendarSelectedHandler.bind(this);
        this.calendarSettingsRefHandler =
            this.calendarSettingsRefHandler.bind(this);
        this.settingsButtonRefHandler =
            this.settingsButtonRefHandler.bind(this);
        this.todayButtonClickedHandler =
            this.todayButtonClickedHandler.bind(this);
    }
    componentWillLoad() {
        this.dateFormat = mapDateFormat(this.dateFormat);
        this.displayDateFormat = mapDateFormat(this.displayDateFormat);
        this.handleCalendarView(this.isCalendarVisible);
        if (_.isEmpty(this.eventDateSeparator))
            this.eventDateSeparator = this.separator;
        /* istanbul ignore else */
        if (this.value) {
            this.values = strToDateObj(this.value, this.separator, this.dateFormat);
        }
        this._days = this._constants.DAYS;
        this._weekend = this._constants.WEEKEND;
        this.today = moment(moment().format(this._dateFormat), this._dateFormat);
        this.initMinMaxDates();
        this.maxDaysSelectable = this.maxDaysSelectable ?? Infinity;
        this.valueStr = valuesToString(this.values, this.activeYear);
        this.selectedDays = new Set(this.valueStr);
        /* istanbul ignore else */
        if (isUsingI18n() && this.namespaceI18n) {
            this.initI18n();
        }
        /* istanbul ignore else */
        if (this.isRange) {
            this.footerTodayLabel = FOOTER_DONE_LABEL;
            this.maxDaysSelectable = Infinity;
            this.rangeHandler();
        }
        this.updateActiveCalendar(this.settingsSelectData, this.footerLabel);
        this.initCalendar(this.initialCalendarValue);
    }
    /**
     * Updates active calendar based on settingsSelectData if available, else sets it to footerLabel
     */
    updateActiveCalendar(settingsSelectData, footerLabel) {
        if (settingsSelectData?.length) {
            const index = settingsSelectData.findIndex((data) => data.isSelected);
            this.activeCalendar = settingsSelectData[index].value.calendar;
            this.footerLabel = this.activeCalendar;
        }
        else {
            this.activeCalendar = footerLabel;
        }
    }
    get calendarValueOnReopen() {
        return this.isHeaderDynamic && (!this.isRange || this.values?.length)
            ? this.valueStr.slice(-1)[0]
            : dateValueToString({
                day: 1,
                month: this.initActiveMonth ?? this.today.month() + 1,
                year: this.initActiveYear ?? this.today.year(),
            });
    }
    get initialCalendarValue() {
        /* istanbul ignore else */
        if (this.valueStr?.length) {
            return this.valueStr.slice(-1)[0];
        }
        /* istanbul ignore else */
        if (this.initWithToday) {
            this.setTodayDate(this.today);
            return null;
        }
        /* istanbul ignore else */
        if (this.initActiveMonth || this.initActiveYear) {
            return this.constructDateFromActiveMonthAndYear();
        }
        return this.shouldUseMaxDateSelectable
            ? dateValueToString(this.maxDateSelectable, +this.activeYear)
            : null;
    }
    get shouldUseMaxDateSelectable() {
        return this.hasMaxDate && !this.isWithinBounds(this.today);
    }
    constructDateFromActiveMonthAndYear() {
        const monthZeroPadding = !this.initActiveMonth || this.initActiveMonth < 10 ? '0' : '';
        const year = this.initActiveYear >= DEFAULT_MIN_YEAR &&
            this.initActiveYear <= DEFAULT_MAX_YEAR
            ? this.initActiveYear
            : moment().year();
        return `01 ${monthZeroPadding}${this.initActiveMonth ? this.initActiveMonth : 1} ${year}`;
    }
    isWithinBounds(dateMoment) {
        /* istanbul ignore else */
        if (!(this.hasMinDate || this.hasMaxDate))
            return true;
        const minDate = this.dateObjToMoment(this.minDateSelectable);
        const maxDate = this.dateObjToMoment(this.maxDateSelectable);
        if (this.hasMinDate && this.hasMaxDate) {
            return dateMoment.isBetween(minDate, maxDate, null, '[]');
        }
        if (this.hasMaxDate) {
            return dateMoment.isSameOrBefore(maxDate);
        }
        return dateMoment.isSameOrAfter(minDate);
    }
    initI18n() {
        this.i18n = new BxfI18n(this.namespaceI18n);
        window['i18n'].on('languageChanged', () => {
            this.i18n.languageChangedHandler(this.translateText());
        });
        window['i18n'].on('loaded', () => {
            this.translateText();
        });
    }
    translateText() {
        Object.entries(this.i18nKeys).forEach(([key, value]) => {
            if (value instanceof Array) {
                this[key] = value.map((day) => this.i18n.getTranslation(day));
            }
            else {
                translateKeys(this, this.i18nKeys, this.i18n);
            }
        });
    }
    componentDidRender() {
        /* istanbul ignore else */
        if (this._calendarRef) {
            this.isCalendarVisible &&
                this.calendarConnected.emit({
                    host: this._calendarRef,
                    eventData: this.eventData,
                });
            this.generateYears();
            this.generateMonths();
            this.initOverlay();
            this.initCalendarTabIndex();
        }
        this.setPrevDisabled();
        this.setNextDisabled();
    }
    disconnectedCallback() {
        if (!this.isCalendarVisible && this._overlay) {
            this._overlay.close();
            this.isSettingsVisible = false;
        }
        this._overlay = null;
        this.i18n?.destroyTranslations();
    }
    updateState(isOpen) {
        this.isSettingsVisible = isOpen;
    }
    rangeHandler() {
        let startRange = null;
        let endRange = null;
        const size = this.values?.length;
        if (size === 2) {
            startRange = this.getMoment(this.valueStr[0]);
            endRange = this.getMoment(this.valueStr[1]);
        }
        else if (size === 1) {
            startRange = this.getMoment(this.valueStr[0]);
            endRange = this._doubleDates ? startRange : null;
        }
        this.startRange = startRange;
        this.endRange = endRange;
        this._doubleDates = startRange?.isSame(endRange) ?? false;
    }
    getMoment(value) {
        return moment(value, this._dateFormat);
    }
    initOverlay() {
        /* istanbul ignore else */
        if (!this._overlay &&
            this._calendarRef &&
            this._settingsButtonRef &&
            this._calendarSettingsRef) {
            this._overlay = new BxfOverlayCalendarSettingsController(this.host, this._calendarRef, this._calendarRef, this._calendarSettingsRef, this.updateState, {
                trigger: BxfOverlayTriggerEnum.PRESSED,
                overlaysToClose: [SETTINGS_CONTAINER$1],
                targetElementOptions: {
                    targetForEventListeners: this._settingsButtonRef,
                    targetEventType: [WindowEventMap.click],
                },
                modifiers: {
                    defaultPlacement: BxfDynamicPositionEnum.LEFT_TOP,
                    flipOrder: [BxfDynamicPositionEnum.LEFT_TOP],
                },
                keepMouseFocus: this.keepMouseFocus,
                closeOnEscape: false, // handle escape in settingsKeyDownHandler to prevent calendar close
                shouldCloseOnMouseUp: true,
                useFocusVisible: true,
                parentContainer: getParentOverlayContainer(this.parentOverlayContainerSelector),
            }, this.isOutsideOverlay);
        }
    }
    isOutsideOverlay(event) {
        return !_.map(eventPath(event), CLASSNAME).find((el) => _.includes(el, SETTINGS_CONTAINER$1));
    }
    setTodayDate(today) {
        /* istanbul ignore else */
        if (this.maxDaysSelectable && this.isWithinBounds(today)) {
            const todayObj = {
                day: this.today.date(),
                month: this.today.month() + 1,
                year: this.today.year(),
            };
            this.values =
                this.maxDaysSelectable === 1
                    ? [todayObj]
                    : this.values.concat(todayObj);
            this.dateSelected.emit({
                value: this.updateCalendarValue(this.today),
                eventData: this.eventData,
                srcEvent: null,
            });
        }
        this.initCalendar(today.format(this._dateFormat)).then(() => {
            this.updateSelectValue();
        });
    }
    updateCalendarValue(date) {
        const value = typeof date === 'string'
            ? moment(date, BxfDatePickerDateFormatEnum.DD_MM_YYYY, true)
            : date;
        const dateFormat = this.isOverlay
            ? this._dateFormat
            : this._dateFormat.replace(SPACE_REGEX, this.eventDateSeparator);
        return value?.format(dateFormat);
    }
    get hasMinDate() {
        return this.minDateSelectable?.year;
    }
    get hasMaxDate() {
        return this.maxDateSelectable?.year;
    }
    get todayEnabled() {
        return (!this.isOverlay || !this.isRange) && this.keepTodayEnabled;
    }
    setPrevDisabled() {
        if (!this.hasMinDate) {
            this.isPrevDisabled = false;
        }
        else {
            const minYear = this.todayEnabled
                ? Math.min(this.minDateSelectable?.year, this.today.year())
                : this.minDateSelectable?.year;
            const minMonth = !this._months.indexOf(this.activeMonth);
            this.isPrevDisabled = +this.activeYear <= minYear && minMonth;
        }
    }
    setNextDisabled() {
        if (!this.hasMaxDate) {
            this.isNextDisabled = false;
        }
        else {
            const maxYear = this.todayEnabled
                ? Math.max(this.maxDateSelectable?.year, this.today.year())
                : this.maxDateSelectable?.year;
            const maxMonth = this._months.indexOf(this.activeMonth) ===
                this._months.length - 1;
            this.isNextDisabled = +this.activeYear >= maxYear && maxMonth;
        }
    }
    generateMonths() {
        let lower = 0;
        let upper = 12;
        if (this.filterMonths) {
            let minYear = this.minDateSelectable.year;
            let maxYear = this.maxDateSelectable.year;
            let minMonth = this.minDateSelectable?.month - 1;
            let maxMonth = this.maxDateSelectable?.month;
            if (this.todayEnabled) {
                minYear = Math.min(this.minDateSelectable.year, this.today.year());
                maxYear = Math.max(this.maxDateSelectable.year, this.today.year());
                minMonth = Math.min(this.minDateSelectable?.month - 1, this.today.month());
                maxMonth = Math.max(this.maxDateSelectable?.month, this.today.month() + 1);
            }
            // upper and lower month bounds to be rendered
            if (+this.activeYear === minYear) {
                lower = minMonth;
            }
            if (+this.activeYear === maxYear) {
                upper = maxMonth;
            }
        }
        this._months = [...this._constants.MONTHS.slice(lower, upper)];
        /* istanbul ignore else */
        if (!this._months.includes(this.activeMonth)) {
            this.activeMonth = this._months[0];
            this.inputValueMoment = moment(this.inputValueMoment, this._dateFormat).month(this.activeMonth);
        }
    }
    getStartYear(currentYear) {
        const startYear = this.activeYear && +this.activeYear <= currentYear - 10
            ? parseInt(this.activeYear, RADIX)
            : currentYear;
        /* istanbul ignore else */
        if (this.hasMinDate) {
            const { year: minYear } = this.minDateSelectable;
            return this.todayEnabled ? Math.min(startYear, minYear) : minYear;
        }
        return startYear - 10;
    }
    getEndYear(currentYear) {
        const endYear = this.activeYear && +this.activeYear >= currentYear + 10
            ? parseInt(this.activeYear, RADIX)
            : currentYear;
        /* istanbul ignore else */
        if (this.hasMaxDate) {
            const { year: maxYear } = this.maxDateSelectable;
            return this.todayEnabled ? Math.max(endYear, maxYear) : maxYear;
        }
        return endYear + 10;
    }
    generateYears() {
        const year = this.today?.year();
        this._years = [];
        for (let i = this.getStartYear(year); i <= this.getEndYear(year); i++) {
            this._years.push(i);
        }
    }
    /**
     * Function initializes calendar with new value from input box
     */
    async initCalendar(newValue) {
        const isRelative = !!(newValue && isRelativeValue(newValue));
        const inputValue = isRelative || _.isEmpty(newValue) ? undefined : newValue;
        const value = inputValue
            ? moment(inputValue, this._dateFormat, true)
            : moment(new Date(undefined));
        // If newValue is defined, then create a temp moment with it;
        // otherwise create a moment with today's date
        let tempMoment = value.isValid()
            ? value
            : moment(moment().format(this._dateFormat), this._dateFormat);
        // If the value of out of the defined date bound, the calendar will initialize on the latest month possible
        const inBounds = this.isWithinBounds(tempMoment);
        /* istanbul ignore else */
        if (!inBounds && this.filterMonths && !this.todayEnabled) {
            tempMoment = moment(newValue ||
                dateValueToString(this.maxDateSelectable, +this.activeYear), this._dateFormat);
        }
        /* istanbul ignore else */
        if (tempMoment.isValid()) {
            this.activeDate = tempMoment.date();
            this.setReset(tempMoment);
            this.activeMonth = tempMoment.format(FULL_MONTH);
            this.activeYear = tempMoment.format(FULL_YEAR);
            this.inputValueMoment = moment(tempMoment, this._dateFormat, true);
            this.generateYears();
            this.generateMonths();
            this.setPrevDisabled();
            this.setNextDisabled();
        }
    }
    /**
     * Sets the month and year that the calendar would transition to if the
     * reset button in the footer were to be clicked.
     */
    setReset(dateMoment) {
        /* istanbul ignore else */
        if (!this.resetValue) {
            this.resetValue = dateMoment.format(this._dateFormat);
        }
    }
    /**
     * Function initializes _minDate object
     */
    initMinDate() {
        /* istanbul ignore else */
        if (this.minDate || this.minYear) {
            this.minDateHandler();
        }
    }
    /**
     * Function initializes _maxDate object
     */
    initMaxDate() {
        /* istanbul ignore else */
        if (this.maxDate || this.maxYear) {
            this.maxDateHandler();
        }
    }
    /**
     * Function initializes _minDate and _maxDate objects
     */
    initMinMaxDates(type) {
        this.initMinDate();
        this.initMaxDate();
        /* istanbul ignore else */
        if (type) {
            this.generateYears();
            this.generateMonths();
        }
    }
    getCalendarMonthSelectedCustomEvent(month) {
        return new CustomEvent('selectionChanged', {
            detail: {
                srcEvent: null,
                value: {
                    bxfId: '',
                    displayValue: month,
                    isSelected: true,
                    value: {
                        key: month,
                        month,
                    },
                },
            },
        });
    }
    getCalendarYearSelectedCustomEvent(year) {
        return new CustomEvent('selectionChanged', {
            detail: {
                srcEvent: null,
                value: {
                    bxfId: '',
                    displayValue: year,
                    isSelected: true,
                    value: {
                        key: year,
                        year,
                    },
                },
            },
        });
    }
    monthSelectionHandler(event) {
        const { detail: { value: { value: { month }, }, } = { value: { value: { month: '' } } }, } = event;
        /* istanbul ignore else */
        if (month && month !== this.activeMonth) {
            this.activeMonth = month;
            this.inputValueMoment = moment(this.inputValueMoment, this._dateFormat).month(month);
            this.monthChanged.emit({
                month: this.activeMonth,
                eventData: this.eventData,
                srcEvent: event,
            });
            this.calendarValueChanged.emit({
                value: this.updateCalendarValue(this.inputValueMoment),
                changeType: 'month',
                dateObject: this.inputValueMoment.toDate(),
                dateMoment: this.inputValueMoment,
                eventData: this.eventData,
                srcEvent: event,
            });
        }
    }
    calendarSelectionHandler(event = {}) {
        const { detail: { value: { value } } = { value: { value: {} } } } = event;
        const newCalendar = value?.calendar;
        /* istanbul ignore else */
        if (newCalendar && newCalendar !== this.activeCalendar) {
            this.activeCalendar = newCalendar;
            this.calendarSelected.emit({
                value,
                eventData: this.eventData,
                srcEvent: event,
            });
        }
    }
    yearSelectionHandler(event) {
        const { detail: { value: { value: { year }, }, } = { value: { value: { year: NaN } } }, } = event;
        /* istanbul ignore else */
        if (year && year !== this.activeYear) {
            this.activeYear = year;
            this.inputValueMoment = moment(this.inputValueMoment, this._dateFormat).year(year);
            this.generateYears();
            this.generateMonths();
            this.yearChanged.emit({
                year: this.activeYear.toString(),
                eventData: this.eventData,
                srcEvent: event,
            });
            this.calendarValueChanged.emit({
                value: this.updateCalendarValue(this.inputValueMoment),
                changeType: 'year',
                dateObject: this.inputValueMoment.toDate(),
                dateMoment: this.inputValueMoment,
                eventData: this.eventData,
                srcEvent: event,
            });
        }
    }
    // TODO: Add CustomEvent type
    dateSelectionHandler(cell, event = {}) {
        const attrs = event.target;
        const date = Number(attrs.getAttribute(this._constants.STRING.DATA_DATE));
        const newMonth = attrs.getAttribute(this._constants.STRING.DATA_MONTH);
        const newYear = Number(attrs.getAttribute(this._constants.STRING.DATA_YEAR));
        /* istanbul ignore else */
        if (date) {
            new Promise((resolve) => {
                this.activeDate = date;
                this.activeMonth = newMonth;
                this.activeYear = newYear;
                this.inputValueMoment = moment(this.inputValueMoment, this._dateFormat)
                    .year(newYear)
                    .month(newMonth)
                    .date(date);
                // Set Value of input box
                const value = this.inputValueMoment.format(this._dateFormat);
                this.setSelectedDays(value);
                this.dateChanged.emit({
                    date: this.activeDate.toString(),
                    eventData: this.eventData,
                    srcEvent: event,
                });
                this.updateSelectValue();
                resolve(true);
            }).then(() => {
                this.highlightCellBasedOnInput(cell);
                this.values = [...this.selectedDays].map((dateStr) => strToDateObj(dateStr, BxfDatePickerSeparatorsEnum.SPACE, this._dateFormat)[0]);
                const values = Array.from(this.selectedDays).map((val) => this.updateCalendarValue(val));
                const ev = this.dateSelected.emit({
                    value: values?.length > 1 ? values : [...values].join(''),
                    eventData: this.eventData,
                    deselectedDay: cell.isSelected
                        ? null
                        : this.updateCalendarValue(cell.dateMoment),
                    srcEvent: event,
                });
                const startDate = [...this.selectedDays][0];
                const endDate = this._doubleDates
                    ? startDate
                    : [...this.selectedDays][1];
                if (this.isRange) {
                    this.rangeDateSelectionChanged.emit({
                        startDate: this.updateCalendarValue(startDate),
                        endDate: this.updateCalendarValue(endDate),
                        eventData: this.eventData,
                        srcEvent: event,
                    });
                }
                this.calendarValueChanged.emit({
                    value: this.updateCalendarValue(this.inputValueMoment),
                    isSelected: cell.isSelected,
                    dateObject: this.inputValueMoment.toDate(),
                    dateMoment: this.inputValueMoment,
                    eventData: this.eventData,
                    srcEvent: event,
                });
                captureDefaultInputEvent(ev);
            });
        }
    }
    setSelectedDays(value) {
        if (this.selectedDays.has(value) && this.isDatesUnselectable) {
            this.selectedDays.delete(value);
            /* istanbul ignore else */
            if (this.isRange) {
                if (this.selectedDays.size || this._doubleDates) {
                    this.startRange = this.inputValueMoment;
                    this._doubleDates = false;
                    this.endRange = null;
                }
                else {
                    this.startRange = this.inputValueMoment;
                    this._doubleDates = true;
                    this.endRange = this.startRange;
                }
                this.selectedDays = new Set([value]);
            }
        }
        else if (this.maxDaysSelectable > 1 &&
            this.selectedDays.size < this.maxDaysSelectable) {
            this.selectedDays.add(value);
            this.handleSelectedRange(value);
        }
        else if (this.maxDaysSelectable === 1) {
            this.selectedDays.clear();
            this.selectedDays.add(value);
        }
    }
    handleSelectedRange(value) {
        /* istanbul ignore else */
        if (this.isRange) {
            if (this.selectedDays.size !== 2 || this._doubleDates) {
                this._doubleDates = false;
                this.selectedDays = new Set([value]);
                this.startRange = this.inputValueMoment;
                this.endRange = null;
            }
            else {
                const a = moment([...this.selectedDays][0], this._dateFormat);
                const b = moment([...this.selectedDays][1], this._dateFormat);
                if (b.isAfter(a)) {
                    this.startRange = a;
                    this.endRange = b;
                }
                else {
                    this.startRange = b;
                    this.selectedDays = new Set([value]);
                    this.endRange = null;
                }
            }
        }
    }
    /**
     * Handle selection of calendar from Settings Panel
     */
    calendarSelectedHandler(event) {
        const { detail: { value }, } = event;
        this.activeCalendar = value.calendar;
        this.footerLabel = this.activeCalendar;
        this.calendarSelected.emit(event.detail);
    }
    settingsButtonRefHandler(el) {
        /* istanbul ignore else */
        if (el) {
            this._settingsButtonRef = el;
            this._settingsButtonRef.addEventListener(WindowEventMap.click, () => {
                this.isSettingsVisible = !this.isSettingsVisible;
            });
            this.initOverlay();
        }
    }
    hoverCellHandler(date) {
        /* istanbul ignore else */
        if (!this._doubleDates &&
            this.selectedDays.size === 1 &&
            !date.isSame(this.endRange)) {
            this.endRange = date;
        }
    }
    /**
     * Handler for when one of the month arrows are clicked.
     * @param event MouseEvent
     * @param isPrev boolean that when true shows that it is handling left arrow click.
     */
    monthClickHandler(event, isPrev) {
        event?.preventDefault();
        const newDate = isPrev
            ? moment(this.inputValueMoment, this._dateFormat).subtract(1, 'month')
            : moment(this.inputValueMoment, this._dateFormat).add(1, 'month');
        const newMonth = newDate.format(FULL_MONTH);
        const newYear = newDate.year();
        const customEvent = this.getCalendarMonthSelectedCustomEvent(newMonth);
        /* istanbul ignore else */
        if (newYear - +this.activeYear) {
            const customYearSelectedEvent = this.getCalendarYearSelectedCustomEvent(newYear);
            this.yearSelectionHandler(customYearSelectedEvent);
        }
        this.monthSelectionHandler(customEvent);
        this.setPrevDisabled();
        this.setNextDisabled();
    }
    todayClickedHandler(event) {
        event?.stopPropagation();
        if (this.todayEnabled ||
            !this.filterMonths ||
            (!this.isFooterDisabled && this.isWithinBounds(this.today))) {
            this.footerClicked.emit({
                footer: true,
                todayInFooter: true,
                isTodayValid: this.isWithinBounds(this.today),
                dateMoment: this.today,
                reset: false,
                eventData: this.eventData,
                srcEvent: event,
            });
            if (!this.isRange) {
                this.setTodayDate(this.today);
                this.isWithinBounds(this.today) &&
                    this.calendarValueChanged.emit({
                        value: this.updateCalendarValue(this.today),
                        dateObject: this.today.toDate(),
                        dateMoment: this.today,
                        eventData: this.eventData,
                        srcEvent: event,
                    });
            }
        }
    }
    resetClickedHandler(event) {
        this.footerClicked.emit({
            footer: true,
            todayInFooter: false,
            reset: true,
            eventData: this.eventData,
            srcEvent: event,
        });
        this.rangeDateSelectionChanged.emit({
            startDate: null,
            endDate: null,
            srcEvent: event,
            eventData: this.eventData,
        });
        this._doubleDates = false;
        this.valueStr = null;
        this.values = null;
        this.selectedDays = new Set();
        this.initCalendar(this.resetValue);
    }
    /**
     * Move focus between focusable children on navigation keys
     */
    navKeyEventHandler(event, focusableChildren) {
        const activeIndex = this.getIndexOfActiveElement(focusableChildren);
        /* istanbul ignore else */
        if (activeIndex !== -1) {
            event.preventDefault();
            const focusIndex = FocusIndexManager.getFocusIndexForNavEvent(focusableChildren, activeIndex, event);
            focusableChildren[activeIndex].tabIndex = -1;
            focusableChildren[focusIndex].tabIndex = 0;
            focusableChildren[focusIndex].focus();
        }
    }
    /**
     * For a given grid cell at <week, day>, handle the following events:
     * - Up/Down arrow key:
     *   - navigate between calendar items with the same weekday (columns)
     * - Left/Right/Home/End:
     * 	- navigate between same week (rows)
     * - Tab:
     *   - reactivate focus ring
     */
    keyDownHandler(event, week, day) {
        const rowKeys = [
            ...FocusIndexManager.HORIZONTAL_NAV_KEYS,
            KeyboardEventKey.Home,
            KeyboardEventKey.End,
        ];
        const colKeys = FocusIndexManager.VERTICAL_NAV_KEYS;
        /* istanbul ignore else */
        if (rowKeys.includes(event.key)) {
            this.navKeyEventHandler(event, this.getRowChildren(week));
        }
        else if (colKeys.includes(event.key)) {
            this.navKeyEventHandler(event, this.getColChildren(day));
        }
    }
    /**
     * Close calendar settings overlay on escape.
     * This handler overrides the overlay controller escape handler,
     * 	preventing Escape from closing both calendar and settings at the
     * 	same time.
     */
    settingsKeyDownHandler(event) {
        /* istanbul ignore else */
        if (FocusIndexManager.ESC_KEYS.includes(event.key)) {
            event.stopPropagation();
            this.closeSettings().then(() => {
                // focus button ref
                this._settingsButtonRef?.focusMainBtn();
            });
        }
    }
    get _monthRef() {
        return this.getSelectRef(this.MONTHS_BXF_ID);
    }
    get _yearRef() {
        return this.getSelectRef(this.YEARS_BXF_ID);
    }
    /**
     * Retrieves the reference to the HTMLBxfSelectElement with the specified UID.
     * @param uid - The UID of the HTMLBxfSelectElement.
     * @returns The reference to the HTMLBxfSelectElement, or null if not found.
     */
    getSelectRef(uid) {
        const selectRef = getReference(BxfSelectConstants.COMPONENT_NAME, uid, this.host);
        if (selectRef) {
            selectRef.shouldCloseOverlays = false;
        }
        return selectRef;
    }
    updateSelectValue() {
        /* istanbul ignore else */
        if (this._monthRef) {
            this._monthRef.setValue({ selectedValue: this.activeMonth });
        }
        /* istanbul ignore else */
        if (this._yearRef) {
            this._yearRef.setValue({
                selectedValue: this.activeYear,
            });
        }
    }
    updateSelectedCellStyling(cell, valid) {
        const tdList = getShadowRootElement(this.host).querySelectorAll(`table.${TABLE} td.${this._constants.STRING.TABLE_CELL_SELECTED}`);
        /* istanbul ignore else */
        if (tdList && tdList.length) {
            // Remove selected cell styling from previously selected cell
            _.forEach(tdList, (td) => td.classList.remove(this._constants.STRING.TABLE_CELL_SELECTED));
        }
        cell.isSelected = valid && cell && this.maxDaysSelectable !== 0;
    }
    showDetails(date) {
        return this.hideDatesOutsideActiveMonth || this.hideInactiveDateDetails
            ? BxfCalendarConstants.MONTHS.indexOf(this.activeMonth) ===
                date?.month()
            : true;
    }
    highlightCellBasedOnInput(cell) {
        let tempMoment = null;
        if (this.maxDaysSelectable === 1) {
            tempMoment = moment([...this.selectedDays][0], this._dateFormat);
        }
        else if ((this.maxDaysSelectable > 1 || _.isNil(this.maxDaysSelectable)) &&
            this.selectedDays.has(cell.getMomentAsString())) {
            tempMoment = moment(cell.getMomentAsString(), this._dateFormat);
        }
        this.updateSelectedCellStyling(cell, this.showDetails(tempMoment) &&
            tempMoment?.isValid() &&
            cell.isSame(tempMoment));
    }
    dateObjToMoment(date) {
        return date
            ? moment(dateValueToString(date, +this.activeYear), this._dateFormat)
            : null;
    }
    /**
     * Returns whether date cell should be disabled.
     */
    isCellDisabled(dateMoment) {
        return ((this.disableWeekends && this.isWeekend(dateMoment)) ||
            this.isCellDisabledDate(dateMoment) ||
            !this.isWithinBounds(dateMoment));
    }
    isCellDisabledDate(dateMoment) {
        /* istanbul ignore else */
        if (this.disabledDates) {
            const disabledDates = valuesToString(this.disabledDates, dateMoment.year(), dateMoment.month() + 1);
            return disabledDates.includes(dateMoment.format(this._dateFormat));
        }
        return false;
    }
    /**
     * Styling for calendar cell
     */
    getCalendarCellCss(cell) {
        if (this.hideDatesOutsideActiveMonth && !this._activeMonthFlag) {
            return TRANSPARENT_CELL;
        }
        const baseCss = `${TABLE_CELL} ${this.isRange &&
            this.selectedDays?.size &&
            this.getRangeCellStyle(cell)} ${cell.getCellCss(this.isRange && this.selectedDays.size === 2)} ${cell.isSelected || this.isDaySelectable() ? '' : CELL_NOT_SELECTABLE} ${this._activeMonthFlag
            ? TABLE_CELL_ACTIVE_MONTH
            : TABLE_CELL_INACTIVE_MONTH}`;
        return getKeyboardFocusCSS(baseCss, this.keepMouseFocus);
    }
    calendarCssRangeHandler(isDisabled) {
        const invalidRangeStyle = isDisabled ? INVALID_RANGE : '';
        return this.selectedDays.size > 1
            ? `${CELL_RANGE_SELECTED} ${invalidRangeStyle}`
            : CELL_RANGE;
    }
    getRangeCellStyle(cell) {
        const inRange = this.endRange?.isValid()
            ? cell.isWithinRange(this.startRange, this.endRange)
            : false;
        return !this._doubleDates && inRange
            ? this.calendarCssRangeHandler(cell.isDisabled)
            : '';
    }
    /**
     * Determines if a cell should be clickable and have hover styling
     */
    isDaySelectable() {
        return (this.maxDaysSelectable !== 0 &&
            (this.selectedDays.size < this.maxDaysSelectable ||
                this.maxDaysSelectable === 1 ||
                _.isNil(this.maxDaysSelectable)) &&
            (this.isHeaderDynamic || this._activeMonthFlag));
    }
    /**
     * Given an array of focusable children, return the index in the array where the active element is
     */
    getIndexOfActiveElement(focusableChildren) {
        const activeElem = FocusTrap.getFocusedElem('document');
        return _.findIndex(focusableChildren, (e) => activeElem === e);
    }
    /**
     * Given a month, get the first non-disabled cell of the month.
     */
    getFirstNonDisabledCellOfMonth(month) {
        const monthCells = Array.from(getShadowRootElement(this.host).querySelectorAll(`[data-month="${month}"]`));
        return _.find(monthCells, (cell) => !cell.disabled);
    }
    /**
     * Get calendar button element for today's date
     */
    getCellForToday() {
        return getShadowRootElement(this.host).querySelector(`button.${TABLE_CELL_TODAY}`);
    }
    /**
     * Get calendar button element for selected date
     */
    getSelectedCell() {
        return getShadowRootElement(this.host).querySelector(`button.${TABLE_CELL_SELECTED}`);
    }
    /**
     * Get all focusable cells in calendar
     */
    getFocusableCells() {
        return Array.from(getShadowRootElement(this.host).querySelectorAll(`button.${TABLE_CELL}[tabindex="0"]`));
    }
    /**
     * Given a week number, get all calendar cells in that week (row in grid).
     */
    getRowChildren(week) {
        const children = Array.from(getShadowRootElement(this.host).querySelectorAll(`[data-week="${week}"]`));
        return _.filter(children, (child) => !child.disabled);
    }
    /**
     * Given a weekday, get all calendar cells for that weekday (column in grid).
     */
    getColChildren(day) {
        const children = Array.from(getShadowRootElement(this.host).querySelectorAll(`[data-weekday="${day}"]`));
        return _.filter(children, (child) => !child.disabled);
    }
    /**
     * On calendar cell click:
     * 	Do nothing if cell disabled
     * 	Select a date if cell not disabled
     */
    cellClickHandler(event, cell) {
        if (cell.isDisabled) {
            event.preventDefault();
            event.stopPropagation();
        }
        else {
            this.dateSelectionHandler(cell, event);
        }
    }
    renderCellWithPopover(cell) {
        return (h("bxf-popover", { ref: (el) => (cell.popoverElement = el), trigger: BxfPopoverTriggerEnum.HOVER, header: this.defaultPopoverHeader, useFocusVisible: true, isCalendar: true, parentOverlayContainerSelector: this.parentOverlayContainerSelector }, this.renderPopover(cell), this.renderCalendarCell(cell)));
    }
    renderPopover(cell) {
        return (h("div", { slot: 'content', class: CELL_POPOVER_CONTAINER }, this.renderPopoverContent([
            cell.holidayPopover,
            cell.markerAPopover,
            cell.markerBPopover,
        ])));
    }
    renderPopoverContent(contents) {
        return contents.map((content, i) => content ? (h("div", { key: uuidv4(), style: { display: 'flex', alignItems: 'center' } }, h("span", { style: this.popoverStyles[i] }), content)) : null);
    }
    get popoverStyles() {
        const defaultStyles = {
            border: 'none',
            fontWeight: 'bold',
            padding: '0',
            overflow: 'visible',
            marginRight: '0.25rem',
        };
        const holidayPopover = {
            ...defaultStyles,
            width: '0.375rem',
            height: '0.375rem',
            backgroundColor: 'var(--calendar__background-color--holiday)',
            borderRadius: '0.5rem',
        };
        const markerAPopover = {
            ...defaultStyles,
            width: '0.35rem',
            height: '0.35rem',
            transform: 'rotate(-45deg)',
            backgroundColor: 'var(--calendar__background-color--markerA)',
        };
        const markerBPopover = {
            ...defaultStyles,
            width: '0',
            height: '0',
            borderLeft: '0.25rem solid transparent',
            borderRight: '0.25rem solid transparent',
            borderBottom: '0.5rem solid var(--calendar__background-color--markerB)',
        };
        return [holidayPopover, markerAPopover, markerBPopover];
    }
    isSelected(cell) {
        return (cell.isSelected ||
            (this.isRange &&
                this.selectedDays?.size === 2 &&
                cell.isWithinRange(this.startRange, this.endRange)));
    }
    /**
     * Close tooltip on keyboard blur
     */
    cellBlurHandler(cell) {
        cell.popoverElement?.close();
    }
    /**
     * Open calendar tooltip on keyboard focus
     */
    cellFocusHandler(cell) {
        cell.popoverElement?.open();
    }
    /**
     * Given an BxfCalendarCell object and a moment object, render cell object
     */
    renderCalendarCell(cell) {
        const date = cell.dateMoment.date();
        const month = cell.dateMoment.format(FULL_MONTH);
        const year = cell.dateMoment.year();
        const week = cell.dateMoment.week();
        const weekday = cell.dateMoment.day();
        const hasDateMarkers = cell.isHoliday || cell.isDateTypeA || cell.isDateTypeB;
        this.highlightCellBasedOnInput(cell);
        const cellCss = this.getCalendarCellCss(cell);
        return (h("td", { ref: (el) => {
                cell.element = el;
            }, slot: 'target', class: cellCss, role: Role.PRESENTATION }, h("button", { role: Role.GRIDCELL, "aria-selected": `${this.isSelected(cell)}`, "aria-current": cell.isToday ? 'date' : null, class: cellCss, disabled: cell.isDisabled, "data-date": date, "data-month": month, "data-year": year, "data-week": week, "data-weekday": weekday, value: date, onMouseMove: this.isRange &&
                (() => this.hoverCellHandler(cell.dateMoment)), onKeyDown: (event) => this.keyDownHandler(event, week, weekday), onClick: (event) => this.cellClickHandler(event, cell), tabIndex: cell.isSelected ? 0 : -1, onFocus: () => this.cellFocusHandler(cell), onBlur: () => this.cellBlurHandler(cell) }, date, h("div", { class: BADGE_POSITIONING$1 }, cell.isHoliday ? h("span", { class: HOLIDAY_BADGE }) : null, cell.isDateTypeA ? (h("span", { class: MARKER_A_BADGE })) : null, cell.isDateTypeB ? (h("span", { class: MARKER_B_BADGE })) : null, !hasDateMarkers ? h("span", { class: BADGE }) : null), cell.isHoliday ? (h("span", { class: BXF_ASSISTIVE_TEXT_HIDDEN }, "- holiday")) : null, cell.isDateTypeA ? (h("span", { class: BXF_ASSISTIVE_TEXT_HIDDEN }, "- marker type a")) : null, cell.isDateTypeB ? (h("span", { class: BXF_ASSISTIVE_TEXT_HIDDEN }, "- marker type b")) : null)));
    }
    constructCell(dateMoment) {
        /* istanbul ignore else */
        if (dateMoment?.isValid()) {
            const cell = new BxfCalendarCell(dateMoment, this._dateFormat, this.isTodayHighlighted);
            cell.isDisabled =
                this.isDisabled || this.isCellDisabled(cell.dateMoment);
            /* istanbul ignore else */
            if (!cell.isDisabled && this.showDetails(dateMoment)) {
                cell.setMarkerData([
                    !this.holidayEnabled ? this.holidays : null,
                    !this.markerAEnabled
                        ? this.customDateMarkerA.events
                        : null,
                    !this.markerBEnabled
                        ? this.customDateMarkerB.events
                        : null,
                ], this.dateFormat, this.separator);
            }
            return cell.hasPopoverInfo() && this.showMarkerPopovers
                ? this.renderCellWithPopover(cell)
                : this.renderCalendarCell(cell);
        }
        return null;
    }
    /**
     * Determines if a given date is on the weekend
     */
    isWeekend(dateMoment) {
        const dayOfWeek = dateMoment.weekday();
        return this._weekend.includes(this._days[dayOfWeek]);
    }
    constructFirstWeekOfMonth(firstDayOfMonth) {
        this._daysCounter = 1;
        this._activeMonthFlag = false;
        const firstWeekOfMonth = [];
        const previousMonth = moment(this.inputValueMoment, this._dateFormat).subtract(1, 'month');
        const numberOfDaysInPreviousMonth = previousMonth.daysInMonth();
        for (let i = numberOfDaysInPreviousMonth - firstDayOfMonth + 1; i <= numberOfDaysInPreviousMonth; i++) {
            firstWeekOfMonth.push(this.constructCell(moment(previousMonth, this._dateFormat).date(i)));
        }
        this._activeMonthFlag = true;
        for (let j = 0; j < 7 - firstDayOfMonth; j++) {
            firstWeekOfMonth.push(this.constructCell(moment(this.inputValueMoment, this._dateFormat).date(this._daysCounter)));
            this._daysCounter++;
        }
        return h("tr", { class: TABLE_ROW }, firstWeekOfMonth);
    }
    constructLastWeekOfMonth(daysInMonth) {
        const lastWeekOfMonth = [];
        for (let i = this._daysCounter; i <= daysInMonth; i++) {
            lastWeekOfMonth.push(this.constructCell(moment(this.inputValueMoment, this._dateFormat).date(i)));
        }
        this._activeMonthFlag = false;
        const nextMonth = moment(this.inputValueMoment, this._dateFormat).add(1, 'month');
        const lastWeekOffset = 7 - (daysInMonth - this._daysCounter + 1);
        for (let j = 1; j <= lastWeekOffset; j++) {
            lastWeekOfMonth.push(this.constructCell(moment(nextMonth, this._dateFormat).date(j)));
        }
        this._daysCounter = 1;
        return h("tr", { class: TABLE_ROW }, lastWeekOfMonth);
    }
    computeWeeksForMonth() {
        /* istanbul ignore else */
        if (this.inputValueMoment) {
            const tempMoment = moment(this.inputValueMoment, this._dateFormat);
            const startWeekOfMonth = tempMoment.startOf('month').week();
            let lastWeekOfMonth = tempMoment.endOf('month').week();
            /* istanbul ignore else */
            if (lastWeekOfMonth === 1) {
                // Last week of any month would be 1, only when it's december and
                // the week overflows as the first week of next year.
                // So we need to set the week to be 52 + 1;
                lastWeekOfMonth = 53;
            }
            const numberOfWeeksInMonth = lastWeekOfMonth - startWeekOfMonth + 1;
            // Sunday = 0, Monday = 1, ..., Saturday = 6
            const firstDayOfMonth = tempMoment.startOf('month').weekday();
            const daysInMonth = tempMoment.daysInMonth();
            // FIRST WEEK
            const monthList = [this.constructFirstWeekOfMonth(firstDayOfMonth)];
            // WEEKS
            for (let i = 1; i < numberOfWeeksInMonth - 1; i++) {
                const week = [];
                for (let j = 0; j < 7; j++) {
                    week.push(this.constructCell(moment(this.inputValueMoment, this._dateFormat).date(this._daysCounter)));
                    this._daysCounter++;
                }
                monthList.push(h("tr", { class: TABLE_ROW }, week));
            }
            // LAST WEEK
            /* istanbul ignore else */
            if (this._daysCounter <= daysInMonth) {
                monthList.push(this.constructLastWeekOfMonth(daysInMonth));
            }
            return monthList;
        }
        return null;
    }
    /**
     * Retrieve tabbable cell as follows:
     *  - If selection in calendar grid, return selection.
     * 	- If today in calendar grid and today not disabled, return today.
     *  - Otherwise, return first non-disabled day of month.
     */
    getTabbableCell() {
        const selectedCell = this.getSelectedCell();
        if (selectedCell && !selectedCell.disabled) {
            return selectedCell;
        }
        if (this.activeMonth === this.today?.format(FULL_MONTH) &&
            this.activeYear === this.today?.format(FULL_YEAR) &&
            !this.isCellDisabled(this.today)) {
            return this.getCellForToday();
        }
        return this.getFirstNonDisabledCellOfMonth(this.activeMonth);
    }
    /**
     * Initialize tabbable cell as follows:
     * - If active month and active year = selected month/year, set to selected.
     * - Otherwise, active month is this month and active year is this year, start tabindex at today's date.
     * - Otherwise, start tabindex at the first of the month.
     * If selected month displayed, do nothing as the selected cell will already have tabindex=0.
     */
    setTabbableCell() {
        const tabIndexStartElem = this.getTabbableCell();
        /* istanbul ignore else */
        if (tabIndexStartElem) {
            tabIndexStartElem.tabIndex = 0;
        }
    }
    /**
     * Set tabindex = -1 for any focusable cells that are NOT equal to selected date
     */
    clearTabIndexForUnselectedCells(selectedMonth, selectedDate, selectedYear) {
        let focusableCells = this.getFocusableCells();
        /* istanbul ignore else */
        if (focusableCells) {
            // filter out any selected cells (tabindex should be 0)
            /* istanbul ignore else */
            if (selectedDate &&
                selectedMonth === this.activeMonth &&
                selectedYear === this.activeYear) {
                focusableCells = _.filter(focusableCells, (cell) => cell.dataset['date'] !== selectedDate.toString());
            }
            _.forEach(focusableCells, (cell) => {
                cell.tabIndex = -1;
            });
        }
    }
    /**
     * focus selection if a table cell is focused
     */
    focusSelection() {
        const selectedElem = this.getSelectedCell();
        const focusedElem = FocusTrap.getFocusedElem(this._tableRef);
        // check if selected elem has focus method prior to focusing
        /* istanbul ignore else */
        if (selectedElem &&
            selectedElem.focus &&
            (focusedElem.classList.contains(TABLE_CELL) ||
                focusedElem.tagName.toLowerCase() === 'body')) {
            selectedElem.focus();
        }
    }
    /**
     * Clear any focusable cells and initialize tabindex for calendar as follows:
     * - If selection displayed, tabindex should start at selection
     * 	and selection should be focused if another cell is focused,
     * 	thus keeping focus inside the calendar grid.
     * - If no selection displayed:
     *   - If calendar shows current month, start tabindex at today's date.
     *   - Otherwise, start tabindex at the first of the shown month.
     */
    initCalendarTabIndex() {
        let selectedYear;
        let selectedMonth;
        let selectedDate;
        /* istanbul ignore else */
        if (this.valueStr) {
            const tempMoment = moment(this.valueStr[0], this._dateFormat);
            selectedYear = tempMoment.format(FULL_YEAR);
            selectedMonth = tempMoment.format(FULL_MONTH);
            selectedDate = tempMoment.date();
        }
        this.clearTabIndexForUnselectedCells(selectedMonth, selectedDate, selectedYear);
        this.setTabbableCell();
        /* istanbul ignore else */
        if (this.getSelectedCell()) {
            this.focusSelection();
        }
    }
    /**
     * Return accessible label for grid and dialog.
     * @see https://www.w3.org/TR/wai-aria-practices-1.1/examples/dialog-modal/datepicker-dialog.html
     */
    getDialogLabel() {
        /* istanbul ignore else */
        return `${this.activeMonth} ${this.activeYear}`;
    }
    renderDateTable() {
        return (h("table", { ref: (el) => {
                this._tableRef = el;
            }, class: `${TABLE} ${this.isFacetBtn ? TABLE_FACET_BTN : ''}`.trim(), role: Role.GRID, onMouseLeave: () => {
                /* istanbul ignore else */
                if (this.selectedDays.size === 1)
                    this.endRange = null;
            }, "aria-label": this.getDialogLabel() }, h("tr", { class: TABLE_ROW, onMouseEnter: () => {
                /* istanbul ignore else */
                if (this.selectedDays.size === 1)
                    this.endRange = null;
            } }, this.allDays.map((day, key) => (h("th", { class: TABLE_HEADER, key: day + key }, h("span", { "aria-hidden": 'true' }, day), h("span", { class: BXF_ASSISTIVE_TEXT_HIDDEN }, this.allFullDays[key]))))), this.computeWeeksForMonth()));
    }
    renderFooter() {
        /* istanbul ignore else */
        if (this.hasCalendarFooter) {
            return (h("footer", { class: FOOTER }, this.renderButtonsInFooter(), h("div", { class: FOOTER_RIGHT$1 }, this.renderLabelInFooter(), !this.isOverlay
                ? this.renderSelection()
                : this.renderSettingsInFooter())));
        }
        return null;
    }
    /**
     * Shared props for all bxf-button elements
     */
    get baseButtonProps() {
        return {
            keepMouseFocus: this.keepMouseFocus,
            size: BxfButtonSizeEnum.SMALL,
        };
    }
    renderTodayButtonInlineMenu() {
        return (h("bxf-inline-menu", { class: TODAY_MENU_CONTAINER, data: this.todayButtonMenuData, parentOverlayContainerSelector: this.parentOverlayContainerSelector, onMenuOpened: (e) => this.todayButtonMenuItemClicked.emit({
                value: null,
                isOpen: true,
                srcEvent: e,
            }), onInlineMenuItemClicked: (event) => {
                event?.stopPropagation();
                this.todayButtonMenuItemClicked.emit({
                    value: event.detail.element,
                    eventData: this.eventData,
                    srcEvent: event,
                });
            }, useFocusVisible: true }, this.renderTodayButton()));
    }
    todayButtonClickedHandler(event) {
        /* istanbul ignore else */
        if (event.detail.mainButtonClicked) {
            this.setTodayDate(this.today);
            this.footerClicked.emit({
                footer: true,
                todayInFooter: true,
                dateMoment: this.today,
                reset: false,
                eventData: this.eventData,
                srcEvent: event,
            });
            this.calendarValueChanged.emit({
                value: this.updateCalendarValue(this.today),
                dateObject: this.today.toDate(),
                dateMoment: this.today,
                eventData: this.eventData,
                srcEvent: event,
            });
        }
    }
    isTodayButtonDisabled() {
        return (this.isFooterDisabled ||
            (!this.isRange &&
                !this.keepTodayEnabled &&
                (this.isCellDisabled(this.today) ||
                    this.isMonthSelectDisabled ||
                    this.isYearSelectDisabled ||
                    this.isDisabled ||
                    !this.isHeaderDynamic)));
    }
    renderTodayButton() {
        // Avoids the presence of a 'Done' button when range calendar is not part range picker
        /* istanbul ignore else */
        if (!this.isOverlay && this.isRange)
            return null;
        return (h("bxf-button", { ...this.baseButtonProps, ref: (el) => {
                /* istanbul ignore else */
                if (el) {
                    this._todayRef = el;
                    if (!this.todayButtonMenuData?.length) {
                        this._todayRef.addEventListener(WindowEventMap.click, this._todayClickHandler);
                    }
                }
            }, class: FOOTER_TODAY, splitIcon: this.todayButtonMenuData?.length
                ? BxfIconTypeEnum['arrow-dropdown']
                : null, splitAssistiveText: this.todayButtonMenuData?.length ? SPLIT_BUTTON_MENU : '', label: this.footerTodayLabel, type: BxfButtonTypeEnum.SECONDARY, slot: 'target', isDisabled: this.isTodayButtonDisabled(), onSplitButtonClicked: this.todayButtonClickedHandler, dataTestSuffix: createSelector('00', this.dataTestSuffix, true) }));
    }
    renderButtonsInFooter() {
        /* istanbul ignore else */
        if (this.hasTodayInFooter && !this.showTodayButtonAsShortcut) {
            return (h("div", { style: { display: 'inline-flex' } }, this.todayButtonMenuData?.length
                ? this.renderTodayButtonInlineMenu()
                : this.renderTodayButton(), this.renderResetButton()));
        }
        return null;
    }
    isResetButtonDisabled() {
        return (!this.values?.length ||
            this.isFooterDisabled ||
            this.isMonthSelectDisabled ||
            this.isYearSelectDisabled ||
            this.isDisabled ||
            !this.isHeaderDynamic);
    }
    resetButtonRefHandler(el) {
        /* istanbul ignore else */
        if (el) {
            this._resetRef = el;
            this._resetRef.addEventListener(WindowEventMap.click, this._resetClickHandler);
        }
    }
    renderResetButton() {
        /* istanbul ignore else */
        if (this.isRange) {
            return (h("bxf-button", { ...this.baseButtonProps, ref: this.resetButtonRefHandler, class: FOOTER_RESET, label: RESET, type: BxfButtonTypeEnum.TERTIARY, isDisabled: !this.values?.length || this.isResetButtonDisabled(), dataTestSuffix: createSelector('01', this.dataTestSuffix, true) }));
        }
        return null;
    }
    renderLabelInFooter() {
        /* istanbul ignore else */
        if (this.hasFooterLabel && this.footerLabel) {
            return (h("div", { class: LABEL$1 }, h("div", { class: FOOTER_LABEL_TEXT }, this.footerLabel)));
        }
        return null;
    }
    renderSelection() {
        return this.settingsSelectData?.length ? (h("bxf-select", { ...this.getBaseSelectProps(), "data-bxf-id": this.CALENDARS_BXF_ID, shouldCloseOverlays: false, "data-test": createSelector(this.host.tagName, this.footerLabel), class: FOOTER_SELECT$1, size: SMALL, isDisabled: this.isFooterDisabled || this.isDisabled, dataTestSuffix: createSelector('02', this.dataTestSuffix, true), parentOverlayContainerSelector: this.parentOverlayContainerSelector, data: [
                {
                    values: this.settingsSelectData,
                },
            ], keepMouseFocus: this.keepMouseFocus })) : null;
    }
    renderSettingsInFooter() {
        /* istanbul ignore else */
        if (this.hasFooterSettings) {
            /* istanbul ignore else */
            const ariaConfig = {
                [AriaAttr.HASPOPUP]: HasPopupValue.DIALOG,
                [AriaAttr.EXPANDED]: String(this.isSettingsVisible),
            };
            return (h("div", { class: FOOTER_SETTINGS }, h("bxf-button", { ...this.baseButtonProps, ref: this.settingsButtonRefHandler, class: FOOTER_SETTINGS_ICON, "data-test": createSelector(this.host.tagName, this.settings), assistiveText: this.settings, type: BxfButtonTypeEnum.TERTIARY_SUBTLE, icon: BxfIconTypeEnum.settings, ariaConfig: ariaConfig, isDisabled: this.isFooterDisabled || this.isDisabled, dataTestSuffix: createSelector('01', this.dataTestSuffix, true) }), this.renderCalendarSettings()));
        }
        return null;
    }
    /**
     * Gets the height of the calendar.
     * @returns {string} The height of the calendar as a string.
     */
    get calendarHeight() {
        if (this._calendarRef) {
            const { top, bottom } = this._calendarRef.getBoundingClientRect();
            return `${bottom - top}`;
        }
        return 'auto';
    }
    /**
     * Render calendar settings dropdown overlay
     * @returns {JSX.Element}
     */
    renderCalendarSettings() {
        const value = ([...this.selectedDays].slice(-1) ?? [null])[0];
        return (h("bxf-calendar-settings", { ref: this.calendarSettingsRefHandler, isSettingsVisible: this.isSettingsVisible, dateFormat: this.dateFormat, displayDateFormat: this.displayDateFormat, hasSeparatorSettings: this.hasSeparatorSettings, hasDateFormatSettings: this.hasDateFormatSettings, separator: this.separator, lastSelectedDay: value, calendarHeight: this.calendarHeight, eventData: this.eventData, settingsSelectData: this.settingsSelectData, dataTestSuffix: this.dataTestSuffix, keepMouseFocus: this.keepMouseFocus, onKeyDown: this.settingsKeyDownHandler, onCalendarSelected: this.calendarSelectedHandler, onSeparatorSelected: (event) => this.separatorSelected.emit(event.detail), namespaceI18n: this.namespaceI18n, i18nKeys: this.calendarSettingsI18nKeys, onDateFormatSelected: (e) => {
                this.dateFormatSelected.emit(e.detail);
            }, parentOverlayContainerSelector: this.parentOverlayContainerSelector }));
    }
    /**
     * Shared props between month and year select components
     */
    getBaseSelectProps() {
        return {
            keepMouseFocus: this.keepMouseFocus,
            hasInitialOptionPlaceholder: false,
            shouldCloseOverlays: false,
        };
    }
    /**
     * Render dropdown for month value.
     */
    renderMonths() {
        return (h("bxf-select", { ...this.getBaseSelectProps(), "data-bxf-id": this.MONTHS_BXF_ID, "data-test": createSelector(this.host.tagName, this.monthLabel), assistiveText: this.monthLabel, class: MONTHS_BOX, isDisabled: this.isMonthSelectDisabled || this.isDisabled, parentOverlayContainerSelector: this.parentOverlayContainerSelector, dataTestSuffix: createSelector('01', this.dataTestSuffix, true), data: [
                {
                    values: _.map(this._months, (month, key) => ({
                        displayValue: month,
                        value: {
                            month,
                            key: month + key,
                        },
                        isSelected: month === this.activeMonth,
                    })),
                },
            ] }));
    }
    /**
     * Render years dropdown
     */
    renderYears() {
        return (h("bxf-select", { ...this.getBaseSelectProps(), "data-bxf-id": this.YEARS_BXF_ID, "data-test": createSelector(this.host.tagName, this.yearLabel), assistiveText: this.yearLabel, class: YEARS_BOX, shouldCloseOverlays: false, isDisabled: this.isYearSelectDisabled || this.isDisabled, parentOverlayContainerSelector: this.parentOverlayContainerSelector, dataTestSuffix: createSelector('01', this.dataTestSuffix, true), data: [
                {
                    values: _.map(this._years, (year, key) => ({
                        displayValue: `${year}`,
                        value: {
                            year,
                            key: year + key,
                        },
                        isSelected: year === +this.activeYear,
                    })),
                },
            ] }));
    }
    /**
     * Render back and forward buttons
     */
    renderButtons() {
        return (h("div", { class: BUTTONS_BOX }, h("bxf-tooltip", { dataTestSuffix: createSelector('03', this.dataTestSuffix, true) }, h("div", { slot: 'target', class: BUTTON_XSMALL }, h("bxf-button", { ...this.baseButtonProps, onClick: (event) => this.monthClickHandler(event, true), class: HEADER_PREV_MONTH, "data-test": createSelector(this.host.tagName, this.prevMonth), assistiveText: this.prevMonth, icon: 'arrow-left', type: BxfButtonTypeEnum.TERTIARY, isDisabled: this.isPrevDisabled || this.isDisabled, dataTestSuffix: createSelector('02', this.dataTestSuffix, true) })), h("div", { slot: 'content' }, this.prevMonth)), h("bxf-tooltip", { dataTestSuffix: createSelector('01', this.dataTestSuffix, true) }, h("div", { slot: 'target', class: BUTTON_XSMALL }, h("bxf-button", { ...this.baseButtonProps, onClick: (event) => this.monthClickHandler(event, false), class: HEADER_NEXT_MONTH, "data-test": createSelector(this.host.tagName, this.nextMonth), assistiveText: this.nextMonth, icon: 'arrow-right', type: BxfButtonTypeEnum.TERTIARY, isDisabled: this.isNextDisabled || this.isDisabled, dataTestSuffix: createSelector('03', this.dataTestSuffix, true) })), h("div", { slot: 'content' }, this.nextMonth))));
    }
    renderSelectableHeader() {
        return (h("header", { class: `${HEADER} ${this.isFacetBtn ? HEADER_FACET_BTN : ''}`.trim() }, this.renderMonths(), this.renderYears(), this.renderButtons()));
    }
    renderStaticHeader() {
        return (h("header", { class: STATIC_HEADER }, h("p", null, `${this.activeMonth} ${this.activeYear}`)));
    }
    renderKeyItems(type) {
        const { event } = type;
        /* istanbul ignore else */
        if (event && Object.keys(event).length) {
            return (h("button", { "data-bxf-id": type.id, onClick: (e) => !(this.isDisabled || this.isFooterDisabled) &&
                    this.keyDisplayChanged.emit({
                        eventData: this.eventData,
                        srcEvent: e,
                        value: type.id,
                    }), class: KEY_ITEM$1 }, h("span", { class: type.markerType, style: type.markerType === MARKER_B_FOOTER_BADGE$1
                    ? { borderBottomColor: type.ref }
                    : {
                        backgroundColor: type.ref,
                    } }), h("span", { class: FOOTER_BADGE_LABEL$1, style: {
                    color: type.ref,
                } }, type.label)));
        }
        return null;
    }
    renderMarkerKey() {
        const hasEvents = !(_.isEmpty(this.holidays) &&
            _.isEmpty(this.customDateMarkerA) &&
            _.isEmpty(this.customDateMarkerB));
        /* istanbul ignore else */
        if (hasEvents && this.hasMarkerKey) {
            const classTypes = [
                {
                    markerType: HOLIDAY_FOOTER_BADGE$1,
                    label: HOLIDAYS_LABEL$1,
                    event: this.holidays,
                    id: this.HOLIDAY_BXF_ID,
                    ref: this.isDisabled || this.isFooterDisabled
                        ? this._secondaryTextColor
                        : this.holidayEnabled,
                },
                {
                    markerType: MARKER_A_FOOTER_BADGE$1,
                    label: this.customDateMarkerA?.markerLabel,
                    event: this.customDateMarkerA?.events,
                    id: this.MARKER_A_BXF_ID,
                    ref: this.isDisabled || this.isFooterDisabled
                        ? this._secondaryTextColor
                        : this.markerAEnabled,
                },
                {
                    markerType: MARKER_B_FOOTER_BADGE$1,
                    label: this.customDateMarkerB?.markerLabel,
                    event: this.customDateMarkerB?.events,
                    id: this.MARKER_B_BXF_ID,
                    ref: this.isDisabled || this.isFooterDisabled
                        ? this._secondaryTextColor
                        : this.markerBEnabled,
                },
            ];
            return (h("div", { class: KEY_CONTAINER$1 }, classTypes.map((type) => this.renderKeyItems(type))));
        }
        return null;
    }
    renderCalendarNote() {
        if (!this.calendarNote)
            return null;
        const { title, note } = this.calendarNote;
        if (note) {
            return (h("div", { class: `${CALENDAR_NOTE_CONTAINER} ${this.isOverlay ? OVERLAY_PADDING : ''}` }, h("span", { class: CALENDAR_NOTE }, h("b", null, `${title ?? ''}${!title || title.endsWith(':') ? ' ' : ': '} `), note)));
        }
        return null;
    }
    renderShortcuts() {
        /* istanbul ignore else */
        if (this.showTodayButtonAsShortcut || this.footerShortcutData?.length) {
            return (h("div", { class: `${SHORTCUTS_CONTAINER} ${this.isOverlay ? OVERLAY_PADDING : ''}` }, this.renderShortcutButtons()));
        }
        return null;
    }
    handleShortcutClick(event, shortcut) {
        if (shortcut.value === this.TODAY_BXF_ID) {
            this.todayClickedHandler(event);
        }
        else {
            this.shortcutClicked.emit({
                value: shortcut,
                srcEvent: event,
                eventData: this.eventData,
            });
        }
    }
    renderShortcutButtons(shortcut) {
        /* istanbul ignore else */
        if (!_.isEmpty(shortcut)) {
            const { value, displayValue } = shortcut;
            return (h("bxf-button", { label: displayValue, key: `${value}-${displayValue}`, type: BxfButtonTypeEnum.TERTIARY, isDisabled: shortcut.isDisabled, size: BxfButtonSizeEnum.REGULAR, assistiveText: value, onClick: (e) => this.handleShortcutClick(e, shortcut) }));
        }
        const data = this
            .showTodayButtonAsShortcut
            ? [
                {
                    displayValue: FOOTER_TODAY_LABEL,
                    value: this.TODAY_BXF_ID,
                    isDisabled: this.isTodayButtonDisabled(),
                },
            ]
            : [];
        const shortcuts = [...data.concat(this.footerShortcutData)];
        return (h("div", { key: `${this.TODAY_BXF_ID}-${FOOTER_TODAY_LABEL}`, style: { display: 'flex' } }, this.renderShortcutButtons(shortcuts[0]), shortcuts.length > 1 &&
            shortcuts.slice(1).map((s) => [
                h("div", { key: `${s.value}-${s.displayValue}-${SEPARATOR}`, class: SHORTCUT_SEPARATOR }, SEPARATOR),
                this.renderShortcutButtons(s),
            ])));
    }
    calendarSettingsRefHandler(el) {
        if (el)
            this._calendarSettingsRef = el;
    }
    calendarRefHandler(el) {
        /* istanbul ignore else */
        if (el) {
            this._calendarRef = el;
        }
    }
    render() {
        const header = this.isHeaderDynamic
            ? this.renderSelectableHeader()
            : this.renderStaticHeader();
        return (h("section", { key: '6469729d22ea2d57b6cd8bcf1862132709fa6e82', ref: this.calendarRefHandler, role: this.isDialog ? DIALOG$1 : Role.PRESENTATION, class: this.isOverlay ? CONTAINER : STANDALONE_CONTAINER, "data-bxf-id": this.eventData?.['bxfId'], style: {
                display: this.calendarDisplayStyle,
            }, "aria-label": this.isDialog && this.getDialogLabel(), "data-test": createSelector(this.host.tagName, this.dataTestSuffix) }, this.renderCalendarNote(), header, this.renderDateTable(), this.renderFooter(), this.renderMarkerKey(), this.renderShortcuts()));
    }
    static get watchers() { return {
        "isCalendarVisible": ["handleCalendarView"],
        "eventDateSeparator": ["eventDateSeparatorChangeHandler"],
        "dateFormat": ["inputDateFormatChangeHandler"],
        "displayDateFormat": ["displayDateFormatChangeHandler"],
        "value": ["singleValueChangeHandler"],
        "values": ["valueChangeHandler"],
        "isSettingsVisible": ["calendarOpenHandler"],
        "minDate": ["minDateHandler"],
        "minYear": ["minDateHandler"],
        "maxDate": ["maxDateHandler"],
        "maxYear": ["maxDateHandler"],
        "footerLabel": ["footerLabelHandler"],
        "settingsSelectData": ["settingsSelectDataHandler"]
    }; }
};
BxfCalendar.style = BxfCalendarStyle0;

const bxfCalendarGroupCss = "button.sc-bxf-calendar-group:hover,a.sc-bxf-calendar-group:hover,input[type=radio].sc-bxf-calendar-group:hover,input[type=checkbox].sc-bxf-calendar-group:hover,input[type=radio].sc-bxf-calendar-group:checked:hover,input[type=checkbox].sc-bxf-calendar-group:checked:hover,svg.sc-bxf-calendar-group:hover{cursor:pointer}svg[disabled].sc-bxf-calendar-group:hover,button[disabled].sc-bxf-calendar-group:hover,label[disabled].sc-bxf-calendar-group:hover,input[type=checkbox].sc-bxf-calendar-group:disabled:hover,input[type=radio].sc-bxf-calendar-group:disabled:hover,input[type=checkbox].sc-bxf-calendar-group:checked:disabled:hover,input[type=radio].sc-bxf-calendar-group:checked:disabled:hover{cursor:default}.bxf__assistive-text--hidden.sc-bxf-calendar-group{position:absolute !important;left:-625rem;top:auto;width:0.0625rem;height:0.0625rem;overflow:hidden}.bxf-calendar__badge.sc-bxf-calendar-group,.bxf-calendar__badge--holiday.sc-bxf-calendar-group,.bxf-calendar__footer__badge--holiday.sc-bxf-calendar-group,.bxf-calendar__badge--markerA.sc-bxf-calendar-group,.bxf-calendar__footer__badge--markerA.sc-bxf-calendar-group,.bxf-calendar__badge--markerB.sc-bxf-calendar-group,.bxf-calendar__footer__badge--markerB.sc-bxf-calendar-group{margin:0.1875rem 0.0625rem 0 0.0625rem;padding:0;width:0.25rem;height:0.25rem;border:none;font-weight:bold}.bxf-calendar__badge--holiday.sc-bxf-calendar-group,.bxf-calendar__footer__badge--holiday.sc-bxf-calendar-group{border-radius:0.5rem;background-color:var(--calendar__background-color--holiday)}.bxf-calendar__footer__badge--holiday.sc-bxf-calendar-group{width:0.375rem;height:0.375rem;display:inline-flex}.bxf-calendar__badge--markerA.sc-bxf-calendar-group,.bxf-calendar__footer__badge--markerA.sc-bxf-calendar-group{transform:rotate(45deg);background-color:var(--calendar__background-color--markerA)}.bxf-calendar-group__container.sc-bxf-calendar-group{display:inline-grid}.bxf-calendar-group__container--space.sc-bxf-calendar-group{padding-right:1.5rem}.bxf-calendar__calendar--row.sc-bxf-calendar-group{display:table-caption}.bxf-calendar-group.sc-bxf-calendar-group{overflow:auto}.bxf-calendar__footer__badge--markerA.sc-bxf-calendar-group{width:0.34375rem;height:0.34375rem;display:inline-flex}.bxf-calendar__badge--markerB.sc-bxf-calendar-group,.bxf-calendar__footer__badge--markerB.sc-bxf-calendar-group{width:0rem;height:0rem;border-left:0.15625rem solid transparent;border-right:0.15625rem solid transparent;border-bottom:0.3125rem solid var(--calendar__background-color--markerB)}.bxf-calendar__footer__badge--markerB.sc-bxf-calendar-group{border-left:0.25rem solid transparent;border-right:0.25rem solid transparent;border-bottom:0.5rem solid var(--calendar__background-color--markerB);display:inline-flex}.bxf-calendar__key__container.sc-bxf-calendar-group{display:inline-flex;padding-bottom:0.25rem;justify-content:space-around}.bxf-calendar__key__container.sc-bxf-calendar-group:hover{cursor:pointer}.bxf-calendar__badge__label.sc-bxf-calendar-group{padding-top:0.1875rem;padding-right:0.25rem;padding-left:0.25rem;color:var(--primary-text__color);font-size:var(--font-size);display:inline-flex}.bxf-calendar__badge__positioning.sc-bxf-calendar-group{display:inline-flex}.bxf-calendar__footer.sc-bxf-calendar-group{height:1.5rem;display:flex;justify-content:space-between}.bxf-calendar__footer--selected.sc-bxf-calendar-group{color:var(--primary-action__color)}.bxf-calendar__footer--right.sc-bxf-calendar-group{display:flex;width:100%;justify-content:right}.bxf-calendar__footer--label.sc-bxf-calendar-group{display:flex;font-size:var(--font-size);padding-top:0.25rem;padding-right:0.5rem;color:var(--secondary-text__color)}.bxf-calendar__footer--select.sc-bxf-calendar-group{width:7.5rem}.bxf-calendar__footer--settings.sc-bxf-calendar-group{display:flex}.bxf-calendar__footer--settings.sc-bxf-calendar-group bxf-button.sc-bxf-calendar-group{line-height:2rem}@media (forced-colors: active){.bxf-calendar__badge--holiday.sc-bxf-calendar-group,.bxf-calendar__footer__badge--holiday.sc-bxf-calendar-group,.bxf-calendar__badge--markerA.sc-bxf-calendar-group,.bxf-calendar__footer__badge--markerA.sc-bxf-calendar-group,.bxf-calendar__badge--markerB.sc-bxf-calendar-group,.bxf-calendar__footer__badge--markerB.sc-bxf-calendar-group{background-color:CanvasText}}";
const BxfCalendarGroupStyle0 = bxfCalendarGroupCss;

const { LABEL, HOLIDAYS_LABEL, KEY_CONTAINER, KEY_ITEM, FOOTER_SELECT, HOLIDAY_FOOTER_BADGE, MARKER_A_FOOTER_BADGE, FOOTER_RIGHT, CALENDAR_GROUP_CONTAINER, CALENDAR_GROUP, BADGE_POSITIONING, MARKER_B_FOOTER_BADGE, SECONDARY_TEXT_COLOR, CALENDAR_ROW, CALENDAR_CONTAINER_SPACE, FOOTER_BADGE_LABEL, } = BxfCalendarConstants.STRING;
const BxfCalendarGroup = class {
    get host() { return getElement(this); }
    // #endregion "Props"
    /**
     * This event is emitted when a calendar is selected in settings panel
     */
    calendarSelected;
    /**
     * This event is emitted when a calendar is selected in settings panel
     */
    selectedDatesChanged;
    keyDisplayChanged;
    selectionChangedHandler(event) {
        this.calendarSelectionHandler(event);
    }
    keyDisplayChangedHandler(event) {
        const bxfId = event.detail?.value;
        /* istanbul ignore else */
        if (bxfId === this.HOLIDAY_BXF_ID) {
            this.holidayEnabled =
                this.holidayEnabled === '' ? this._secondaryTextColor : '';
        }
        else if (bxfId === this.MARKER_A_BXF_ID) {
            this.markerAEnabled =
                this.markerAEnabled === '' ? this._secondaryTextColor : '';
        }
        else if (bxfId === this.MARKER_B_BXF_ID) {
            this.markerBEnabled =
                this.markerBEnabled === '' ? this._secondaryTextColor : '';
        }
    }
    dataChangeHandler() {
        if (this.data) {
            this._data = this.splitToRows();
        }
    }
    /**
     * Update activeCalendar state when settingsSelectData dynamically changed
     */
    settingsSelectDataChangeHandler(newValue, oldValue) {
        if (!isEqual(newValue, oldValue)) {
            this.updateActiveCalendar(newValue);
        }
    }
    HOLIDAY_BXF_ID = uuidv4();
    MARKER_A_BXF_ID = uuidv4();
    MARKER_B_BXF_ID = uuidv4();
    _labelId = uuidv4();
    _secondaryTextColor = SECONDARY_TEXT_COLOR;
    componentWillLoad() {
        this._data = this.splitToRows();
        this.valStrArr = valuesToString(this.values);
        this.maxSelected = this.values.length >= this.maxDaysSelectable;
        this.updateActiveCalendar(this.settingsSelectData);
    }
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.calendarSelected = createEvent(this, "calendarSelected", 7);
        this.selectedDatesChanged = createEvent(this, "selectedDatesChanged", 7);
        this.keyDisplayChanged = createEvent(this, "keyDisplayChanged", 7);
        this.label = '';
        this.data = [];
        this.values = [];
        this.settingsSelectData = [];
        this.hideInactiveDateDetails = true;
        this.selectLabel = 'Default, US';
        this.keepMouseFocus = false;
        this.parentOverlayContainerSelector = 'body';
        this.dataTestSuffix = undefined;
        this.calendarsPerRow = 3;
        this.disableWeekends = false;
        this.showMarkerKey = true;
        this.showMarkerPopovers = true;
        this.holidays = {};
        this.customDateMarkerA = {};
        this.customDateMarkerB = {};
        this.maxDaysSelectable = 1;
        this.isTodayHighlighted = true;
        this.isTracking = true;
        this.eventData = {};
        this.trackingData = undefined;
        this.assistiveText = '';
        this.disabledDates = [];
        this.hideDatesOutsideActiveMonth = false;
        this.activeCalendar = undefined;
        this.maxSelected = false;
        this._data = [];
        this.valStrArr = undefined;
        this.holidayEnabled = '';
        this.markerAEnabled = '';
        this.markerBEnabled = '';
        this.calendarValuesChangeHandler =
            this.calendarValuesChangeHandler.bind(this);
    }
    /**
     * Update activeCalendar state based on settingsSelectData
     */
    updateActiveCalendar(settingsSelectData) {
        if (settingsSelectData?.length) {
            const index = settingsSelectData.findIndex((data) => data.isSelected);
            this.activeCalendar = settingsSelectData[index].value.calendar;
        }
    }
    valuesToObject(values) {
        const newVal = [...values];
        return newVal.map((value) => {
            const valArr = value.split('-');
            return { day: +valArr[0], month: +valArr[1], year: +valArr[2] };
        });
    }
    calendarValuesChangeHandler(event) {
        const { value } = event.detail;
        if (this.maxDaysSelectable === 1) {
            this.valStrArr = [value];
        }
        else if (!event.detail.isSelected) {
            this.valStrArr = this.valStrArr.filter((item) => item !== value);
        }
        else if (!this.valStrArr.includes(value)) {
            this.valStrArr.push(value);
        }
        this.values = [...this.valuesToObject(this.valStrArr)];
        this.selectedDatesChanged.emit({
            values: this.valStrArr,
            eventData: this.eventData,
        });
    }
    splitToRows() {
        const array = [...this.data];
        const result = [];
        while (array.length > this.calendarsPerRow) {
            result.push(array.splice(0, this.calendarsPerRow));
        }
        result.push(array);
        return result;
    }
    renderRow(rowData) {
        return rowData?.map((calendar, index) => {
            const dataTestSuffix = index + 1 < 10 ? `0${index + 1}` : `${index + 1}`;
            return (h("div", { key: dataTestSuffix, class: CALENDAR_CONTAINER_SPACE }, h("bxf-calendar", { initActiveMonth: calendar.month, holidays: this.holidays, dataTestSuffix: createSelector(`${dataTestSuffix}`, this.dataTestSuffix, true), customDateMarkerA: this.customDateMarkerA, customDateMarkerB: this.customDateMarkerB, maxDaysSelectable: this.maxDaysSelectable, hasMarkerKey: false, hideDatesOutsideActiveMonth: this.hideDatesOutsideActiveMonth, disableWeekends: this.disableWeekends || calendar.disableWeekends, initActiveYear: calendar.year, disabledDates: this.disabledDates, hideInactiveDateDetails: this.hideInactiveDateDetails, isHeaderDynamic: false, isFooterDisabled: true, isDialog: false, footerLabel: '', isTodayHighlighted: this.isTodayHighlighted, isCalendarVisible: true, hasTodayInFooter: false, eventData: this.eventData, showMarkerPopovers: this.showMarkerPopovers, values: this.values, onCalendarValueChanged: this.calendarValuesChangeHandler, parentOverlayContainerSelector: this.parentOverlayContainerSelector })));
        });
    }
    renderKeyItems(type) {
        const { event } = type;
        if (event && Object.keys(event).length) {
            return (h("span", { "data-bxf-id": type.id, onClick: (e) => this.keyDisplayChanged.emit({
                    eventData: this.eventData,
                    srcEvent: e,
                    value: type.id,
                }), class: KEY_ITEM }, h("span", { class: type.markerType, style: type.markerType === MARKER_B_FOOTER_BADGE
                    ? { borderBottomColor: type.ref }
                    : {
                        backgroundColor: type.ref,
                    } }), h("span", { class: FOOTER_BADGE_LABEL, style: {
                    color: type.ref,
                } }, type.label)));
        }
        return null;
    }
    renderMarkerKey() {
        const hasEvents = !(isEmpty(this.holidays) &&
            isEmpty(this.customDateMarkerA) &&
            isEmpty(this.customDateMarkerB));
        if (hasEvents) {
            const classTypes = [
                {
                    markerType: HOLIDAY_FOOTER_BADGE,
                    label: HOLIDAYS_LABEL,
                    event: this.holidays,
                    id: this.HOLIDAY_BXF_ID,
                    ref: this.holidayEnabled,
                },
                {
                    markerType: MARKER_A_FOOTER_BADGE,
                    label: this.customDateMarkerA?.markerLabel,
                    event: this.customDateMarkerA?.events,
                    id: this.MARKER_A_BXF_ID,
                    ref: this.markerAEnabled,
                },
                {
                    markerType: MARKER_B_FOOTER_BADGE,
                    label: this.customDateMarkerB?.markerLabel,
                    event: this.customDateMarkerB?.events,
                    id: this.MARKER_B_BXF_ID,
                    ref: this.markerBEnabled,
                },
            ];
            return (h("div", { class: KEY_CONTAINER }, classTypes.map((type) => this.renderKeyItems(type))));
        }
        return null;
    }
    calendarSelectionHandler(event = {}) {
        const { detail: { value: { value } } = { value: { value: {} } } } = event;
        if (value.calendar && value.calendar !== this.activeCalendar) {
            this.activeCalendar = value.calendar;
            this.calendarSelected.emit({
                value,
                eventData: this.eventData,
                srcEvent: event,
            });
        }
    }
    renderLabelInFooter() {
        /* istanbul ignore else */
        if (this.selectLabel) {
            return h("span", { class: LABEL }, this.selectLabel);
        }
        return null;
    }
    renderSelection() {
        return (h("div", { class: FOOTER_RIGHT }, this.renderLabelInFooter(), h("bxf-select", { keepMouseFocus: this.keepMouseFocus, hasInitialOptionPlaceholder: false, shouldCloseOverlays: false, "data-test": createSelector(this.host.tagName, this.label), class: FOOTER_SELECT, size: 'small', parentOverlayContainerSelector: this.parentOverlayContainerSelector, dataTestSuffix: createSelector('00', this.dataTestSuffix, true), data: [
                {
                    values: this.settingsSelectData,
                },
            ] })));
    }
    renderContent() {
        return this._data?.map((rowData, index) => {
            const key = index + 1 < 10 ? `0${index + 1}` : `${index + 1}`;
            return (h("div", { key: key, class: BADGE_POSITIONING }, this.renderRow(rowData)));
        });
    }
    render() {
        return (h("div", { key: '025c81b2490bd1d8b743cbe3cd1272f80e408b29', class: CALENDAR_GROUP_CONTAINER }, this.settingsSelectData.length ? this.renderSelection() : null, h("div", { key: '3d5610a03d6c104d1d391eb151b1c29456c57c28', class: CALENDAR_GROUP }, h("div", { key: 'cf7d75938e07a6d2bba3ee1698f6b28cf4a64f9a', class: CALENDAR_ROW }, h("br", { key: '69fda9feed5c005ae70f709c8f14d5bc65cefcdf' }), h("div", { key: '95493756f7b0f8c83ecaf0ca7517bc48db482cdb', role: Role.GROUP, "aria-labelledby": this.label ? this._labelId : null, "aria-label": this.label ? null : this.assistiveText }, this.renderContent()))), this.showMarkerKey ? this.renderMarkerKey() : null));
    }
    static get watchers() { return {
        "data": ["dataChangeHandler"],
        "settingsSelectData": ["settingsSelectDataChangeHandler"]
    }; }
};
BxfCalendarGroup.style = BxfCalendarGroupStyle0;

const bxfCalendarSettingsCss = "button.sc-bxf-calendar-settings:hover,a.sc-bxf-calendar-settings:hover,input[type=radio].sc-bxf-calendar-settings:hover,input[type=checkbox].sc-bxf-calendar-settings:hover,input[type=radio].sc-bxf-calendar-settings:checked:hover,input[type=checkbox].sc-bxf-calendar-settings:checked:hover,svg.sc-bxf-calendar-settings:hover{cursor:pointer}svg[disabled].sc-bxf-calendar-settings:hover,button[disabled].sc-bxf-calendar-settings:hover,label[disabled].sc-bxf-calendar-settings:hover,input[type=checkbox].sc-bxf-calendar-settings:disabled:hover,input[type=radio].sc-bxf-calendar-settings:disabled:hover,input[type=checkbox].sc-bxf-calendar-settings:checked:disabled:hover,input[type=radio].sc-bxf-calendar-settings:checked:disabled:hover{cursor:default}.bxf__assistive-text--hidden.sc-bxf-calendar-settings{position:absolute !important;left:-625rem;top:auto;width:0.0625rem;height:0.0625rem;overflow:hidden}.bxf-calendar-settings__container.sc-bxf-calendar-settings{display:block;padding:1.25rem 1.25rem 1.5rem;border:1px solid var(--calendar__border-color--menu);border-bottom:1px solid var(--primary-action__color);border-radius:0.125rem;box-sizing:border-box;background-color:var(--widget__background-color);box-shadow:0 0.25rem 0.75rem 0 var(--elevation__box-shadow-color);font-size:0.8125rem;overflow-y:hidden;color:var(--primary-text__color)}.bxf-calendar-settings__container.sc-bxf-calendar-settings:focus{outline:none}.bxf-calendar-settings__calendars.sc-bxf-calendar-settings{margin-right:1.25rem;margin-bottom:1.5rem;width:7.75rem;height:2rem;outline:none}";
const BxfCalendarSettingsStyle0 = bxfCalendarSettingsCss;

const { CALENDAR_LABEL, CALENDARS_BOX, SETTINGS_LABEL, RADIO_LABEL, SETTINGS_CONTAINER, DEFAULT_US, SEPARATOR_LABEL, DIALOG, } = BxfCalendarConstants.STRING;
const { DEFAULT_DAY, DEFAULT_MONTH } = BxfCalendarSettingsConstants.STRING;
const BxfCalendarSettings = class {
    _dateFormatRadioData;
    separatorOptions;
    CALENDARS_BXF_ID = uuidv4();
    SEPARATORS_BXF_ID = uuidv4();
    i18n;
    get host() { return getElement(this); }
    /**
     * @internal
     * This event is emitted when settings panel is rendered
     */
    calendarSettingsConnected;
    /**
     * This event is emitted when a calendar is selected in settings panel
     */
    calendarSelected;
    /**
     * This event is emitted when a separator is selected in settings panel
     */
    separatorSelected;
    /**
     * This event is emitted when date format is selected in settings panel
     */
    dateFormatSelected;
    selectionChangedHandler(event) {
        const select = eventPath(event).find((elm) => elm.nodeName === BxfSelectConstants.COMPONENT_NAME.toUpperCase());
        const bxfId = get(select, 'dataset.bxfId');
        if (bxfId === this.CALENDARS_BXF_ID) {
            this.calendarSelectionHandler(event);
        }
        else if (bxfId === this.SEPARATORS_BXF_ID) {
            this.separatorSelectionHandler(event);
        }
    }
    separatorChangedHandler() {
        this.updateSettings();
    }
    dateFormatChangedHandler() {
        this.updateSettings();
    }
    /**
     * Update activeCalendar state when settingsSelectData dynamically changed
     */
    settingsSelectDataChangedHandler(newValue, oldValue) {
        if (!isEqual(newValue, oldValue)) {
            this.updateActiveCalendar(newValue);
        }
    }
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.calendarSettingsConnected = createEvent(this, "calendarSettingsConnected", 7);
        this.calendarSelected = createEvent(this, "calendarSelected", 7);
        this.separatorSelected = createEvent(this, "separatorSelected", 7);
        this.dateFormatSelected = createEvent(this, "dateFormatSelected", 7);
        this.isSettingsVisible = false;
        this.dateFormat = BxfDatePickerDateFormatEnum.DD_MM_YYYY;
        this.displayDateFormat = BxfDatePickerDateFormatEnum.DD_MMM_YYYY;
        this.separator = BxfDatePickerSeparatorsEnum.DASH;
        this.lastSelectedDay = undefined;
        this.eventData = {};
        this.calendarHeight = 'auto';
        this.settingsSelectData = [];
        this.parentOverlayContainerSelector = 'body';
        this.dataTestSuffix = undefined;
        this.hasSeparatorSettings = true;
        this.hasDateFormatSettings = true;
        this.keepMouseFocus = false;
        this.namespaceI18n = undefined;
        this.i18nKeys = undefined;
        this.activeCalendar = DEFAULT_US;
        this.radioLabel = RADIO_LABEL;
        this.settingsLabel = SETTINGS_LABEL;
        this.calendarLabel = CALENDAR_LABEL;
        this.separatorLabel = SEPARATOR_LABEL;
        this.dateFormatRadioDataChangedHandler =
            this.dateFormatRadioDataChangedHandler.bind(this);
    }
    componentWillLoad() {
        this._dateFormatRadioData = Object.keys(BxfDatePickerDateFormatEnum).map((dateFormat) => {
            return {
                label: this.getFormattedDate(dateFormat),
                secondaryLabel: `(${dateFormat.replace(/_/g, this.separator)})`,
                checked: this.displayDateFormat === this.dateFormat &&
                    this.dateFormat ===
                        dateFormat.replace(/_/g, BxfDatePickerSeparatorsEnum.SPACE),
                disabled: false,
                eventData: dateFormat,
            };
        });
        /* istanbul ignore else */
        if (isUsingI18n() && this.namespaceI18n) {
            this.initI18n();
        }
        this.updateActiveCalendar(this.settingsSelectData);
        this.separatorOptions = [
            {
                values: [
                    ...Object.entries(BxfDatePickerSeparatorsEnum).map((entry) => {
                        const v = entry[0].replace(/_/g, ' ');
                        return {
                            value: entry[0],
                            displayValue: `${v.charAt(0).toUpperCase() +
                                v.substring(1).toLowerCase()} ${entry[1] ===
                                BxfDatePickerSeparatorsEnum.SPACE
                                ? ''
                                : `( ${entry[1]} )`}`.trim(),
                            isSelected: entry[1] === this.separator,
                        };
                    }),
                ],
            },
        ];
    }
    initI18n() {
        this.i18n = new BxfI18n(this.namespaceI18n);
        window['i18n'].on('languageChanged', () => {
            this.i18n.languageChangedHandler(this.translateText());
        });
        window['i18n'].on('loaded', () => {
            this.translateText();
        });
    }
    translateText() {
        translateKeys(this, this.i18nKeys, this.i18n);
    }
    componentDidRender() {
        if (this.isSettingsVisible) {
            this.calendarSettingsConnected.emit({ host: this.host });
        }
    }
    disconnectedCallback() {
        this.i18n?.destroyTranslations();
    }
    /**
     * Update active calendar based on selection from settingsSelectData
     */
    updateActiveCalendar(settingsSelectData) {
        /* istanbul ignore else */
        if (settingsSelectData?.length) {
            const index = settingsSelectData.findIndex((data) => data.isSelected);
            this.activeCalendar = settingsSelectData[index].value.calendar;
        }
    }
    updateSettings() {
        this.separatorOptions[0].values?.forEach((data) => (data.isSelected =
            this.separator === BxfDatePickerSeparatorsEnum[data.value]));
        const temp = [...this._dateFormatRadioData];
        temp.forEach((data) => {
            const dateFormat = BxfDatePickerDateFormatEnum[data.eventData];
            data.label = this.getFormattedDate(dateFormat);
            data.secondaryLabel = `(${dateFormat.replace(SPACE_REGEX, this.separator)})`;
            data.checked =
                this.displayDateFormat === this.dateFormat &&
                    this.dateFormat ===
                        dateFormat.replace(/_/g, BxfDatePickerSeparatorsEnum.SPACE);
        });
        this._dateFormatRadioData = temp;
    }
    getFormattedDate(dateFormat) {
        const defaultDateMoment = moment()
            .date(DEFAULT_DAY)
            .month(DEFAULT_MONTH);
        const newDateFormat = dateFormat.replace(/\s|_/g, this.separator);
        return this.lastSelectedDay
            ? moment(this.lastSelectedDay, BxfDatePickerDateFormatEnum.DD_MM_YYYY).format(newDateFormat)
            : defaultDateMoment.format(newDateFormat);
    }
    dateFormatRadioDataChangedHandler(event = {}) {
        const { detail: { value: { eventData }, }, } = event;
        const dateFormat = BxfDatePickerDateFormatEnum[eventData];
        if (dateFormat) {
            this.dateFormatSelected.emit({
                dateFormat,
                eventData: this.eventData,
                srcEvent: event,
            });
        }
    }
    calendarSelectionHandler(event = {}) {
        const { detail: { value: { value } } = { value: { value: {} } } } = event;
        if (value.calendar && value.calendar != this.activeCalendar) {
            this.activeCalendar = value.calendar;
            this.calendarSelected.emit({
                value,
                eventData: this.eventData,
                srcEvent: event,
            });
        }
    }
    separatorSelectionHandler(event = {}) {
        const separator = BxfDatePickerSeparatorsEnum[event.detail?.value?.value];
        if (separator !== this.separator) {
            this.separator = separator;
            this.separatorSelected.emit({
                separator,
                eventData: this.eventData,
                srcEvent: event,
            });
        }
    }
    /**
     * Render dialog content if settings are visible.
     * NOTE: dialog wrapper needs to render first so that focus trap can
     * 	work properly, as isSettingsVisible isn't updated until updateState callback
     */
    renderDialogContents() {
        if (this.isSettingsVisible) {
            return (h("div", null, this.settingsSelectData &&
                this.settingsSelectData.length ? (h("bxf-select", { "data-bxf-id": this.CALENDARS_BXF_ID, "data-test": createSelector(this.host.tagName, this.calendarLabel), label: this.calendarLabel, isLeftLabel: true, class: CALENDARS_BOX, hasInitialOptionPlaceholder: false, shouldCloseOverlays: false, dataTestSuffix: this.dataTestSuffix, parentOverlayContainerSelector: this.parentOverlayContainerSelector, data: [
                    {
                        values: this.settingsSelectData,
                    },
                ], keepMouseFocus: this.keepMouseFocus })) : null, this.hasSeparatorSettings && (h("bxf-select", { "data-bxf-id": this.SEPARATORS_BXF_ID, "data-test": createSelector(this.host.tagName, this.separatorLabel), label: this.separatorLabel, isLeftLabel: true, class: CALENDARS_BOX, hasInitialOptionPlaceholder: false, shouldCloseOverlays: false, dataTestSuffix: this.dataTestSuffix, data: this.separatorOptions, keepMouseFocus: this.keepMouseFocus, parentOverlayContainerSelector: this.parentOverlayContainerSelector })), this.hasDateFormatSettings && (h("bxf-radio-group", { "data-test": createSelector(this.host.tagName, this.radioLabel), isStacked: true, label: this.radioLabel, dataTestSuffix: this.dataTestSuffix, data: this._dateFormatRadioData, onRadioGroupChanged: this.dateFormatRadioDataChangedHandler, keepMouseFocus: this.keepMouseFocus }))));
        }
    }
    render() {
        return (h("section", { key: '13ec001ca789b4265936bc3b54bfbaf439bab9b0', role: DIALOG, class: SETTINGS_CONTAINER, style: {
                minHeight: this.calendarHeight
                    ? `${this.calendarHeight}px`
                    : 'auto',
            }, "aria-label": this.settingsLabel, "data-test": createSelector(this.host.tagName, this.dataTestSuffix) }, this.renderDialogContents()));
    }
    static get watchers() { return {
        "separator": ["separatorChangedHandler"],
        "lastSelectedDay": ["separatorChangedHandler"],
        "dateFormat": ["dateFormatChangedHandler"],
        "displayDateFormat": ["dateFormatChangedHandler"],
        "settingsSelectData": ["settingsSelectDataChangedHandler"]
    }; }
};
BxfCalendarSettings.style = BxfCalendarSettingsStyle0;

export { BxfCalendar as bxf_calendar, BxfCalendarGroup as bxf_calendar_group, BxfCalendarSettings as bxf_calendar_settings };
